window.verdaderoStores = 


[

    
 {
   "ACCOUNT NAME": "10th Street Liquor",
   "DELIVERY ADDRESS": "1214 10th Street",
   "CITY, STATE, ZIP": "Galveston, TX 77550",
   "ZIP CODE": 77550,
   "Latitude": 29.30186,
   "Longitude": -94.776182
 },
 {
   "ACCOUNT NAME": "21 Plus Liquor",
   "DELIVERY ADDRESS": "10601 Ranch Road 2222 #F",
   "CITY, STATE, ZIP": "Austin, TX 78730",
   "ZIP CODE": 78730,
   "Latitude": 30.393089,
   "Longitude": -97.842875
 },
 {
   "ACCOUNT NAME": "34 Wine and Spirits",
   "DELIVERY ADDRESS": "4601 Southwest Pkwy #100",
   "CITY, STATE, ZIP": "Austin, TX 78735",
   "ZIP CODE": 78735,
   "Latitude": 30.239471,
   "Longitude": -97.831814
 },
 {
   "ACCOUNT NAME": "512 Liquors",
   "DELIVERY ADDRESS": "950 W University Ave Ste 205",
   "CITY, STATE, ZIP": "Georgetown, TX 78626",
   "ZIP CODE": 78626,
   "Latitude": 30.632577,
   "Longitude": -97.68869
 },
 {
   "ACCOUNT NAME": "620 Liquor",
   "DELIVERY ADDRESS": "17420 N FM 620 suite 130",
   "CITY, STATE, ZIP": "Round Rock, TX 78681",
   "ZIP CODE": 78681,
   "Latitude": 30.415529,
   "Longitude": -97.847968
 },
 {
   "ACCOUNT NAME": "812 Liquor",
   "DELIVERY ADDRESS": "105 Acuna Ct.",
   "CITY, STATE, ZIP": "Del Valle, TX 78617",
   "ZIP CODE": 78617,
   "Latitude": 30.099978,
   "Longitude": -97.604999
 },
 {
   "ACCOUNT NAME": "AB Liquor",
   "DELIVERY ADDRESS": "2036 US 183 #200",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.62821,
   "Longitude": -97.866085
 },
 {
   "ACCOUNT NAME": "AB Liquor #2 (Austin)",
   "DELIVERY ADDRESS": "1809 W ANDERSON LN",
   "CITY, STATE, ZIP": "Austin, TX 78757",
   "ZIP CODE": 78757,
   "Latitude": 30.353303,
   "Longitude": -97.725586
 },
 {
   "ACCOUNT NAME": "All Star Liquor",
   "DELIVERY ADDRESS": "5725 Williams Dr. #120",
   "CITY, STATE, ZIP": "Georgetown, TX 78633",
   "ZIP CODE": 78633,
   "Latitude": 30.703808,
   "Longitude": -97.750369
 },
 {
   "ACCOUNT NAME": "All Star Liquor - Leander Rd.",
   "DELIVERY ADDRESS": "1011 LEANDER RD STE 102",
   "CITY, STATE, ZIP": "Georgetown, TX 78628",
   "ZIP CODE": 78628,
   "Latitude": 30.6202,
   "Longitude": -97.691892
 },
 {
   "ACCOUNT NAME": "All Star Liquor - Taylor",
   "DELIVERY ADDRESS": "3100 N MAIN ST STE 127",
   "CITY, STATE, ZIP": "Taylor, TX 76574",
   "ZIP CODE": 76574,
   "Latitude": 30.594795,
   "Longitude": -97.412476
 },
 {
   "ACCOUNT NAME": "All Star Liquor - Temple",
   "DELIVERY ADDRESS": "2934 S 31ST ST",
   "CITY, STATE, ZIP": "Temple, TX 76502",
   "ZIP CODE": 76502,
   "Latitude": 31.071982,
   "Longitude": -97.36945
 },
 {
   "ACCOUNT NAME": "Alma's Liquor",
   "DELIVERY ADDRESS": "3920 Williams Drive Suite 202",
   "CITY, STATE, ZIP": "Georgetown, TX 78628",
   "ZIP CODE": 78628,
   "Latitude": 30.673918,
   "Longitude": -97.70336
 },
 {
   "ACCOUNT NAME": "Andy's Liquors",
   "DELIVERY ADDRESS": "9616 N Lamar Blvd",
   "CITY, STATE, ZIP": "Austin, TX 78753",
   "ZIP CODE": 78753,
   "Latitude": 30.366803,
   "Longitude": -97.695605
 },
 {
   "ACCOUNT NAME": "Avery Ranch Wine & Spirits",
   "DELIVERY ADDRESS": "10510 W Parmer Lane # 118",
   "CITY, STATE, ZIP": "Austin, TX 78717",
   "ZIP CODE": 78717,
   "Latitude": 30.496498,
   "Longitude": -97.774191
 },
 {
   "ACCOUNT NAME": "Awesome Liquors",
   "DELIVERY ADDRESS": "2418 RR 620 S #200",
   "CITY, STATE, ZIP": "Lakeway, TX 78738",
   "ZIP CODE": 78738,
   "Latitude": 30.392441,
   "Longitude": -97.876748
 },
 {
   "ACCOUNT NAME": "Bastrop Liquor & Smoke Shop",
   "DELIVERY ADDRESS": "103 State Hwy 71W",
   "CITY, STATE, ZIP": "Bastrop, TX",
   "ZIP CODE": 78602,
   "Latitude": 30.103704,
   "Longitude": -97.321031
 },
 {
   "ACCOUNT NAME": "BB LIQUOR",
   "DELIVERY ADDRESS": "4435 N STATE HIGHWAY 123 STE 206",
   "CITY, STATE, ZIP": "San Marcos, TX 78666",
   "ZIP CODE": 78666,
   "Latitude": 29.806874,
   "Longitude": -97.944457
 },
 {
   "ACCOUNT NAME": "BB Liquor 2",
   "DELIVERY ADDRESS": "1050 Bunton Creek Road Suite 170",
   "CITY, STATE, ZIP": "Kyle, TX 78640",
   "ZIP CODE": 78640,
   "Latitude": 30.004203,
   "Longitude": -97.856317
 },
 {
   "ACCOUNT NAME": "Bergheim Cellars",
   "DELIVERY ADDRESS": "1 FM 3351",
   "CITY, STATE, ZIP": "Boerne, TX 78006",
   "ZIP CODE": 78006,
   "Latitude": 29.825873,
   "Longitude": -98.573107
 },
 {
   "ACCOUNT NAME": "Beverage Delite Liquor Store",
   "DELIVERY ADDRESS": "6565 Babcock Rd #18",
   "CITY, STATE, ZIP": "San Antonio, TX 78249",
   "ZIP CODE": 78249,
   "Latitude": 29.555792,
   "Longitude": -98.614476
 },
 {
   "ACCOUNT NAME": "Blackhawk Liquor",
   "DELIVERY ADDRESS": "20205 FM 685",
   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
   "ZIP CODE": 78660,
   "Latitude": 30.484083,
   "Longitude": -97.583866
 },
 {
   "ACCOUNT NAME": "Boggy's Liquor",
   "DELIVERY ADDRESS": "4712 Lohman Ford Rd. Ste. 200",
   "CITY, STATE, ZIP": "Lago Vista, TX 78645",
   "ZIP CODE": 78645,
   "Latitude": 30.434303,
   "Longitude": -97.978575
 },
 {
   "ACCOUNT NAME": "Buda Liquor",
   "DELIVERY ADDRESS": "17020 S I-35 Frontage Rd Suite A1-B1",
   "CITY, STATE, ZIP": "Buda, TX 78610",
   "ZIP CODE": 78610,
   "Latitude": 30.060784,
   "Longitude": -97.834261
 },
 {
   "ACCOUNT NAME": "Castle Liquor",
   "DELIVERY ADDRESS": "1290 Bebee Rd. #300",
   "CITY, STATE, ZIP": "Kyle, TX 78640",
   "ZIP CODE": 78640,
   "Latitude": 30.018843,
   "Longitude": -97.842491
 },
 {
   "ACCOUNT NAME": "Cedar Liquor",
   "DELIVERY ADDRESS": "729 E. Slaughter Ln. Ste, B",
   "CITY, STATE, ZIP": "Austin, TX 78744",
   "ZIP CODE": 78744,
   "Latitude": 30.160339,
   "Longitude": -97.777125
 },
 {
   "ACCOUNT NAME": "Cedar Liquor #2",
   "DELIVERY ADDRESS": "729 E SLAUGHTER LN STE B AUSTIN, TX 78744",
   "CITY, STATE, ZIP": "Austin, TX 78725",
   "ZIP CODE": 78725,
   "Latitude": 30.160339,
   "Longitude": -97.777125
 },
 {
   "ACCOUNT NAME": "Cedar Valley Liquor",
   "DELIVERY ADDRESS": "12002 W Hwy 290",
   "CITY, STATE, ZIP": "Austin, TX 78737",
   "ZIP CODE": 78737,
   "Latitude": 30.211522,
   "Longitude": -97.96897
 },
 {
   "ACCOUNT NAME": "Cedar Valley Spirits",
   "DELIVERY ADDRESS": "12002 US-290",
   "CITY, STATE, ZIP": "Austin, TX 78737",
   "ZIP CODE": 78737,
   "Latitude": 30.234388,
   "Longitude": -97.911837
 },
 {
   "ACCOUNT NAME": "Chris' Liquor 3",
   "DELIVERY ADDRESS": "6800 West Gate Blvd",
   "CITY, STATE, ZIP": "Austin, TX 78745",
   "ZIP CODE": 78745,
   "Latitude": 30.20917,
   "Longitude": -97.815907
 },
 {
   "ACCOUNT NAME": "Chris' Liquor Stores",
   "DELIVERY ADDRESS": "2203 S Lamar Blvd.",
   "CITY, STATE, ZIP": "Austin, TX 78704",
   "ZIP CODE": 78704,
   "Latitude": 30.247298,
   "Longitude": -97.773228
 },
 {
   "ACCOUNT NAME": "Circle B Liquor",
   "DELIVERY ADDRESS": "1108 FM 1431",
   "CITY, STATE, ZIP": "Marble Falls, TX 78654",
   "ZIP CODE": 78654,
   "Latitude": 30.579588,
   "Longitude": -98.276148
 },
 {
   "ACCOUNT NAME": "Clint's Liquor #10",
   "DELIVERY ADDRESS": "3651 N US HWY 183 #160",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.705279,
   "Longitude": -97.875695
 },
 {
   "ACCOUNT NAME": "Clint's Liquor #7",
   "DELIVERY ADDRESS": "940 Westinghouse Rd. #100",
   "CITY, STATE, ZIP": "Georgetown, TX 78626",
   "ZIP CODE": 78626,
   "Latitude": 30.581431,
   "Longitude": -97.676291
 },
 {
   "ACCOUNT NAME": "Clint's Liquor #8",
   "DELIVERY ADDRESS": "12518 Research Blvd. # H",
   "CITY, STATE, ZIP": "Austin, TX 78759",
   "ZIP CODE": 78759,
   "Latitude": 30.431179,
   "Longitude": -97.764562
 },
 {
   "ACCOUNT NAME": "Clint's Liquors #4",
   "DELIVERY ADDRESS": "16009 FM 1325 Suite 204",
   "CITY, STATE, ZIP": "Austin, TX 78728",
   "ZIP CODE": 78728,
   "Latitude": 30.471438,
   "Longitude": -97.690971
 },
 {
   "ACCOUNT NAME": "Clint's Liquor #3",
   "DELIVERY ADDRESS": "195 S HASLER BLVD STE A",
   "CITY, STATE, ZIP": "Bastrop,TX 78602",
   "ZIP CODE": 78602,
   "Latitude": 30.105775,
   "Longitude": -97.335375
 },
 {
   "ACCOUNT NAME": "Clint's Liquor #5",
   "DELIVERY ADDRESS": "211 W HIGHWAY 79",
   "CITY, STATE, ZIP": "THRALL, TX 76578",
   "ZIP CODE": 76578,
   "Latitude": 30.591152,
   "Longitude": -97.301382
 },
 {
   "ACCOUNT NAME": "King's Liquor",
   "DELIVERY ADDRESS": "619 N MAIN ST",
   "CITY, STATE, ZIP": "Taylor, TX 76574",
   "ZIP CODE": 76574,
   "Latitude": 30.57323,
   "Longitude": -97.410345
 },
 {
   "ACCOUNT NAME": "Cold Springs Liquor",
   "DELIVERY ADDRESS": "15609 Ronald Reagan Blvd. Suite B-100",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.564032,
   "Longitude": -97.801166
 },
 {
   "ACCOUNT NAME": "Cold Springs Liquor Liberty Hill",
   "DELIVERY ADDRESS": "9073 W State HWY 29 STE 112",
   "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
   "ZIP CODE": 78642,
   "Latitude": 30.641738,
   "Longitude": -97.840343
 },
 {
   "ACCOUNT NAME": "Country Life Wine & Spirits",
   "DELIVERY ADDRESS": "4520 Farm to Market 1626 Suite 200",
   "CITY, STATE, ZIP": "Kyle, TX 78640",
   "ZIP CODE": 78640,
   "Latitude": 30.023392,
   "Longitude": -97.872945
 },
 {
   "ACCOUNT NAME": "Country Life Wine & Spirits #2",
   "DELIVERY ADDRESS": "8947 FM 2244 RD STE 206",
   "CITY, STATE, ZIP": "Austin, TX 78746",
   "ZIP CODE": 78746,
   "Latitude": 30.317581,
   "Longitude": -97.863684
 },
 {
   "ACCOUNT NAME": "Crowne Liquor",
   "DELIVERY ADDRESS": "2211 TX-46 STE 102",
   "CITY, STATE, ZIP": "New Braunfels, TX 78130",
   "ZIP CODE": 78130,
   "Latitude": 29.663741,
   "Longitude": -98.049878
 },
 {
   "ACCOUNT NAME": "Dany's Liquor",
   "DELIVERY ADDRESS": "2700 West Pecan Street",
   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
   "ZIP CODE": 78660,
   "Latitude": 30.450026,
   "Longitude": -97.656574
 },
 {
   "ACCOUNT NAME": "Deb's Liquor",
   "DELIVERY ADDRESS": "10740 Research Blvd. #135",
   "CITY, STATE, ZIP": "Austin, TX 78759",
   "ZIP CODE": 78759,
   "Latitude": 30.396691,
   "Longitude": -97.745609
 },
 {
   "ACCOUNT NAME": "Don's Liquor",
   "DELIVERY ADDRESS": "100 E Whitestone Blvd #140",
   "CITY, STATE, ZIP": "Cedar Park, TX 78613",
   "ZIP CODE": 78613,
   "Latitude": 30.522173,
   "Longitude": -97.830196
 },
 {
   "ACCOUNT NAME": "Don's Liquor #2 - Leander",
   "DELIVERY ADDRESS": "12681 Hero Way Suite B",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.573215,
   "Longitude": -97.881709
 },
 {
   "ACCOUNT NAME": "Don's Liquor 183",
   "DELIVERY ADDRESS": "2403 S Hwy 183 #101",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.547243,
   "Longitude": -97.842107
 },
 {
   "ACCOUNT NAME": "Don's Liquor Wells Branch",
   "DELIVERY ADDRESS": "3407 Wells Branch Pkwy",
   "CITY, STATE, ZIP": "Austin, TX 78728",
   "ZIP CODE": 78728,
   "Latitude": 30.439784,
   "Longitude": -97.697077
 },
 {
   "ACCOUNT NAME": "East Village Liquor",
   "DELIVERY ADDRESS": "3500 E. Parmer Lane Suite 2142",
   "CITY, STATE, ZIP": "Austin, TX 78754",
   "ZIP CODE": 78754,
   "Latitude": 30.376107,
   "Longitude": -97.629812
 },
 {
   "ACCOUNT NAME": "Economy Liquor",
   "DELIVERY ADDRESS": "1911 23rd Street",
   "CITY, STATE, ZIP": "Galveston, TX 77550",
   "ZIP CODE": 77550,
   "Latitude": 29.291993,
   "Longitude": -94.789054
 },
 {
   "ACCOUNT NAME": "Everest Liquor",
   "DELIVERY ADDRESS": "1900 University Boulevard #140",
   "CITY, STATE, ZIP": "Round Rock, TX 78665",
   "ZIP CODE": 78665,
   "Latitude": 30.572311,
   "Longitude": -97.653305
 },
 {
   "ACCOUNT NAME": "Fion Liquor",
   "DELIVERY ADDRESS": "1200 Lakeway Dr #14",
   "CITY, STATE, ZIP": "Lakeway, TX 78734",
   "ZIP CODE": 78734,
   "Latitude": 30.363594,
   "Longitude": -97.981605
 },
 {
   "ACCOUNT NAME": "Freedom Libations",
   "DELIVERY ADDRESS": "15050 W State Hwy 29 ste 180",
   "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
   "ZIP CODE": 78642,
   "Latitude": 30.67536,
   "Longitude": -97.931384
 },
 {
   "ACCOUNT NAME": "Freedom Libations-Round Rock",
   "DELIVERY ADDRESS": "2800 E. Palm Valley Blvd Suite 140",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.523181,
   "Longitude": -97.639635
 },
 {
   "ACCOUNT NAME": "Friday Night Liquors",
   "DELIVERY ADDRESS": "409 W Front St STE 130",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "Latitude": 30.541322,
   "Longitude": -97.54897
 },
 {
   "ACCOUNT NAME": "Galaxy Liquors",
   "DELIVERY ADDRESS": "2030 E Oltorf St. ste 112",
   "CITY, STATE, ZIP": "Austin, TX 78741",
   "ZIP CODE": 78741,
   "Latitude": 30.230786,
   "Longitude": -97.732156
 },
 {
   "ACCOUNT NAME": "Galveston Liquor",
   "DELIVERY ADDRESS": "4613 Fort Crockett Blvd",
   "CITY, STATE, ZIP": "Galveston, TX 77551",
   "ZIP CODE": 77551,
   "Latitude": 29.275613,
   "Longitude": -94.812526
 },
 {
   "ACCOUNT NAME": "Geek Liquor",
   "DELIVERY ADDRESS": "2051 W. FM 1626 ste B",
   "CITY, STATE, ZIP": "Manchaca, TX 78652",
   "ZIP CODE": 78652,
   "Latitude": 30.139349,
   "Longitude": -97.847119
 },
 {
   "ACCOUNT NAME": "Georgetown Liquor",
   "DELIVERY ADDRESS": "1202 S Main St.",
   "CITY, STATE, ZIP": "Georgetown, TX 78626",
   "ZIP CODE": 78626,
   "Latitude": 30.633057,
   "Longitude": -97.677401
 },
 {
   "ACCOUNT NAME": "Gunter's Liquor",
   "DELIVERY ADDRESS": "11150 Research Blvd Suite 103B",
   "CITY, STATE, ZIP": "Austin, TX 78759",
   "ZIP CODE": 78759,
   "Latitude": 30.403956,
   "Longitude": -97.746099
 },
 {
   "ACCOUNT NAME": "Hall's Liquor",
   "DELIVERY ADDRESS": "2121 45th Street",
   "CITY, STATE, ZIP": "Galveston, TX 77550",
   "ZIP CODE": 77550,
   "Latitude": 29.283128,
   "Longitude": -94.81389
 },
 {
   "ACCOUNT NAME": "Happy Hill Country Liquor",
   "DELIVERY ADDRESS": "719 US-183 Suite B-102",
   "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
   "ZIP CODE": 78642,
   "Latitude": 30.64275,
   "Longitude": -97.870377
 },
 {
   "ACCOUNT NAME": "Happy Town Liquor",
   "DELIVERY ADDRESS": "1552 FM 685 #105",
   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
   "ZIP CODE": 78660,
   "Latitude": 30.453065,
   "Longitude": -97.604304
 },
 {
   "ACCOUNT NAME": "Hippo Liquor Stop",
   "DELIVERY ADDRESS": "3333 CR 119 Suite 6",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "Latitude": 30.580907,
   "Longitude": -97.571743
 },
 {
   "ACCOUNT NAME": "Hoekstra Bros.",
   "DELIVERY ADDRESS": "9408 E HWY 71 Unit  A",
   "CITY, STATE, ZIP": "Spicewood, TX 78669",
   "ZIP CODE": 78669,
   "Latitude": 30.462452,
   "Longitude": -98.1604
 },
 {
   "ACCOUNT NAME": "Hutto Liquor",
   "DELIVERY ADDRESS": "525 Chris Kelley Blvd Unit 2",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "Latitude": 30.53227,
   "Longitude": -97.563677
 },
 {
   "ACCOUNT NAME": "Jacob's Liquor",
   "DELIVERY ADDRESS": "11410 Menchaca Rd  #300",
   "CITY, STATE, ZIP": "Austin, TX 78748",
   "ZIP CODE": 78748,
   "Latitude": 30.154195,
   "Longitude": -97.833752
 },
 {
   "ACCOUNT NAME": "JC Liquors",
   "DELIVERY ADDRESS": "100 US Highway 281 N.",
   "CITY, STATE, ZIP": "Johnson City, TX 78636",
   "ZIP CODE": 78636,
   "Latitude": 30.278182,
   "Longitude": -98.404469
 },
 {
   "ACCOUNT NAME": "Jenn's Beer, Wine & Spirits",
   "DELIVERY ADDRESS": "1210 Madrid St",
   "CITY, STATE, ZIP": "Castroville, TX 78009",
   "ZIP CODE": 78009,
   "Latitude": 29.351498,
   "Longitude": -98.885387
 },
 {
   "ACCOUNT NAME": "JJ Liquor",
   "DELIVERY ADDRESS": "30070 US-281 #218",
   "CITY, STATE, ZIP": "Bulverde, TX 78163",
   "ZIP CODE": 78163,
   "Latitude": 29.741272,
   "Longitude": -98.435354
 },
 {
   "ACCOUNT NAME": "JJ Liquor 3",
   "DELIVERY ADDRESS": "1 FM 3351 S STE 150",
   "CITY, STATE, ZIP": "Boerne, TX 78006",
   "ZIP CODE": 78006,
   "Latitude": 29.825873,
   "Longitude": -98.573107
 },
 {
   "ACCOUNT NAME": "Johnnie's Liquor Store",
   "DELIVERY ADDRESS": "13201 Pond Springs Rd. Ste 203",
   "CITY, STATE, ZIP": "Austin, TX 78729",
   "ZIP CODE": 78729,
   "Latitude": 30.445399,
   "Longitude": -97.778201
 },
 {
   "ACCOUNT NAME": "King Liquor",
   "DELIVERY ADDRESS": "5310 Burnet Road #100",
   "CITY, STATE, ZIP": "Austin, TX 78756",
   "ZIP CODE": 78756,
   "Latitude": 30.327056,
   "Longitude": -97.740583
 },
 {
   "ACCOUNT NAME": "King Liquor (Georgetown)",
   "DELIVERY ADDRESS": "221 FM 971 ste. #102",
   "CITY, STATE, ZIP": "Georgetown, TX 78626",
   "ZIP CODE": 78626,
   "Latitude": 30.656134,
   "Longitude": -97.666322
 },
 {
   "ACCOUNT NAME": "King Liquor 2 (Georgetown - Williams)",
   "DELIVERY ADDRESS": "3010 WILLIAMS DR STE 123",
   "CITY, STATE, ZIP": "Georgetown, TX 78628",
   "ZIP CODE": 78628,
   "Latitude": 30.662578,
   "Longitude": -97.693281
 },
 {
   "ACCOUNT NAME": "King Liquor-San Antonio",
   "DELIVERY ADDRESS": "20711 Wilderness Oak Suite 112",
   "CITY, STATE, ZIP": "San Antonio, TX 78258",
   "ZIP CODE": 78258,
   "Latitude": 29.635114,
   "Longitude": -98.5165
 },
 {
   "ACCOUNT NAME": "Lafitte's Liquor & Fine Wine LLC",
   "DELIVERY ADDRESS": "18601 Ranch Rd 1431 Ste 101",
   "CITY, STATE, ZIP": "Jonestown, TX 78645",
   "ZIP CODE": 78645,
   "Latitude": 30.595536,
   "Longitude": -97.990082
 },
 {
   "ACCOUNT NAME": "Lakeside Liquor ",
   "DELIVERY ADDRESS": "3390 18100, FM306 Suite 130",
   "CITY, STATE, ZIP": "Canyon Lake, TX 78133",
   "ZIP CODE": 78133,
   "Latitude": 29.91366,
   "Longitude": -98.214182
 },
 {
   "ACCOUNT NAME": "Lakeside Liquors 1",
   "DELIVERY ADDRESS": "11725 W Adams Ave.",
   "CITY, STATE, ZIP": "Temple, TX 76513",
   "ZIP CODE": 76513,
   "Latitude": 31.128424,
   "Longitude": -97.467864
 },
 {
   "ACCOUNT NAME": "Lakeside Wine and Spirits",
   "DELIVERY ADDRESS": "7708 Lohman Ford Road Suite D101",
   "CITY, STATE, ZIP": "Lago Vista, TX 78645",
   "ZIP CODE": 78645,
   "Latitude": 30.472869,
   "Longitude": -97.9766
 },
 {
   "ACCOUNT NAME": "Liquor 29",
   "DELIVERY ADDRESS": "9073 W State Hwy 29 UNIT 112",
   "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
   "ZIP CODE": 78642,
   "Latitude": 30.641738,
   "Longitude": -97.840343
 },
 {
   "ACCOUNT NAME": "Liquor Store",
   "DELIVERY ADDRESS": "102 E Hallmark Avenue",
   "CITY, STATE, ZIP": "Killeen, TX 76541",
   "ZIP CODE": 76541,
   "Latitude": 31.112324,
   "Longitude": -97.73306
 },
 {
   "ACCOUNT NAME": "Liquor Xpress",
   "DELIVERY ADDRESS": "1093 N Hwy 95 Suite 102",
   "CITY, STATE, ZIP": "Bastrop, TX 78602",
   "ZIP CODE": 78602,
   "Latitude": 30.175468,
   "Longitude": -97.315693
 },
 {
   "ACCOUNT NAME": "Lone Star Spirits",
   "DELIVERY ADDRESS": "14150 US-281 Unit B",
   "CITY, STATE, ZIP": "Spring Branch, TX 78070",
   "ZIP CODE": 78070,
   "Latitude": 29.933521,
   "Longitude": -98.412183
 },
 {
   "ACCOUNT NAME": "LoneStar Elite Liquor",
   "DELIVERY ADDRESS": "5725 WILLIAMS DR STE 120",
   "CITY, STATE, ZIP": "Georgetown, TX 78633",
   "ZIP CODE": 78633,
   "Latitude": 30.703808,
   "Longitude": -97.750369
 },
 {
   "ACCOUNT NAME": "Long Branch Liquor",
   "DELIVERY ADDRESS": "4201 E Rancier Ave #109",
   "CITY, STATE, ZIP": "Killeen, TX 76543",
   "ZIP CODE": 76543,
   "Latitude": 31.11643,
   "Longitude": -97.683168
 },
 {
   "ACCOUNT NAME": "M & R Liquors",
   "DELIVERY ADDRESS": "13133 - B LOUETTA RD",
   "CITY, STATE, ZIP": "CYPRESS, TX 77429",
   "ZIP CODE": 77429,
   "Latitude": 29.995028,
   "Longitude": -95.621159
 },
 {
   "ACCOUNT NAME": "Mad Rooster's - Dripping Springs",
   "DELIVERY ADDRESS": "31560 RANCH ROAD 12 UNIT 206",
   "CITY, STATE, ZIP": "Dripping Springs, TX 78620",
   "ZIP CODE": 78620,
   "Latitude": 30.207521,
   "Longitude": -98.087774
 },
 {
   "ACCOUNT NAME": "Mad Rooster's - Wimberley",
   "DELIVERY ADDRESS": "111 OLD KYLE RD STE 310",
   "CITY, STATE, ZIP": "Wimberley, TX 78676",
   "ZIP CODE": 78676,
   "Latitude": 29.996918,
   "Longitude": -98.095381
 },
 {
   "ACCOUNT NAME": "Mad Rooster's Warehouse",
   "DELIVERY ADDRESS": "6601 FM 3237 STE 105",
   "CITY, STATE, ZIP": "Wimberley, TX 78676",
   "ZIP CODE": 78676,
   "Latitude": 30.035042,
   "Longitude": -98.034229
 },
 {
   "ACCOUNT NAME": "Monarch Liquor",
   "DELIVERY ADDRESS": "1902 E. Martin Luther King Jr. Blvd. Suite A",
   "CITY, STATE, ZIP": "Austin, TX 78702",
   "ZIP CODE": 78702,
   "Latitude": 30.280111,
   "Longitude": -97.72082
 },
 {
   "ACCOUNT NAME": "Monarch Liquor II",
   "DELIVERY ADDRESS": "1700 RANCH ROAD 620 N STE 107B",
   "CITY, STATE, ZIP": "Lakeway, TX 78734",
   "ZIP CODE": 78734,
   "Latitude": 30.345959,
   "Longitude": -97.965157
 },
 {
   "ACCOUNT NAME": "Moon Dance Spirits & Wine",
   "DELIVERY ADDRESS": "3720 Gattis School Rd. ste. #900",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.498817,
   "Longitude": -97.615579
 },
 {
   "ACCOUNT NAME": "Brodie's Liquor",
   "DELIVERY ADDRESS": "7612 BRODIE LN STE B",
   "CITY, STATE, ZIP": "Austin, TX 78745",
   "ZIP CODE": 78745,
   "Latitude": 30.206995,
   "Longitude": -97.835244
 },
 {
   "ACCOUNT NAME": "Liquor Xpress #2",
   "DELIVERY ADDRESS": "14815 DESSAU RD STE 200",
   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
   "ZIP CODE": 78660,
   "Latitude": 30.420349,
   "Longitude": -97.628118
 },
 {
   "ACCOUNT NAME": "Z's Liquor",
   "DELIVERY ADDRESS": "14509 FM 969 UNIT 101",
   "CITY, STATE, ZIP": "Austin, TX 78724",
   "ZIP CODE": 78724,
   "Latitude": 30.247738,
   "Longitude": -97.583676
 },
 {
   "ACCOUNT NAME": "My Choice Liquor",
   "DELIVERY ADDRESS": "1601 S Interstate 35 #390",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.494412,
   "Longitude": -97.676765
 },
 {
   "ACCOUNT NAME": "Near Me Liquor",
   "DELIVERY ADDRESS": "11521 N FM 620, STE 300",
   "CITY, STATE, ZIP": "Austin, TX 78726",
   "ZIP CODE": 78726,
   "Latitude": 30.454661,
   "Longitude": -97.825896
 },
 {
   "ACCOUNT NAME": "New Lago Liquor",
   "DELIVERY ADDRESS": "6015 Lohman Ford Road",
   "CITY, STATE, ZIP": "Lago Vista, TX 78645",
   "ZIP CODE": 78645,
   "Latitude": 30.450413,
   "Longitude": -97.97869
 },
 {
   "ACCOUNT NAME": "Nic's Liquor",
   "DELIVERY ADDRESS": "13225 George Bush Street",
   "CITY, STATE, ZIP": "Manor, TX 78653",
   "ZIP CODE": 78653,
   "Latitude": 30.351091,
   "Longitude": -97.527009
 },
 {
   "ACCOUNT NAME": "Oak N Vine Liquor",
   "DELIVERY ADDRESS": "601 W New Hope Dr Suite 105",
   "CITY, STATE, ZIP": "Cedar Park , TX 78613",
   "ZIP CODE": 78613,
   "Latitude": 30.531182,
   "Longitude": -97.842332
 },
 {
   "ACCOUNT NAME": "Old School Liquor & Market",
   "DELIVERY ADDRESS": "1901 W William Cannon Dr Suite 165B",
   "CITY, STATE, ZIP": "Austin, TX 78745",
   "ZIP CODE": 78745,
   "Latitude": 30.201885,
   "Longitude": -97.805059
 },
 {
   "ACCOUNT NAME": "Oliver's Southern Spirits",
   "DELIVERY ADDRESS": "205 TX-7",
   "CITY, STATE, ZIP": "Eddy, TX 76524",
   "ZIP CODE": 76524,
   "Latitude": 31.290746,
   "Longitude": -97.240839
 },
 {
   "ACCOUNT NAME": "One Stop Liquor",
   "DELIVERY ADDRESS": "12135 Potranco Rd",
   "CITY, STATE, ZIP": "San Antonio, TX 78253",
   "ZIP CODE": 78253,
   "Latitude": 29.431932,
   "Longitude": -98.73284
 },
 {
   "ACCOUNT NAME": "Palm Valley Liquors",
   "DELIVERY ADDRESS": "4500 E. Palm Valley Blvd. Suite 114",
   "CITY, STATE, ZIP": "Round Rock, TX 78665",
   "ZIP CODE": 78665,
   "Latitude": 30.533019,
   "Longitude": -97.616292
 },
 {
   "ACCOUNT NAME": "PK Operators",
   "DELIVERY ADDRESS": "302 Sam Houston Drive",
   "CITY, STATE, ZIP": "Victoria, TX 77901",
   "ZIP CODE": 77901,
   "Latitude": 28.817751,
   "Longitude": -96.96841
 },
 {
   "ACCOUNT NAME": "Pojo's Liquor & Gifts",
   "DELIVERY ADDRESS": "815 TX-35",
   "CITY, STATE, ZIP": "Port Lavaca, TX 77979",
   "ZIP CODE": 77979,
   "Latitude": 28.631825,
   "Longitude": -96.632506
 },
 {
   "ACCOUNT NAME": "Proof Liquor & Deli",
   "DELIVERY ADDRESS": "3420 FM 967 STE B107",
   "CITY, STATE, ZIP": "BUDA, TX 78610",
   "ZIP CODE": 78610,
   "Latitude": 30.09607,
   "Longitude": -97.880923
 },
 {
   "ACCOUNT NAME": "Propose Liquor",
   "DELIVERY ADDRESS": "614 E University Ave",
   "CITY, STATE, ZIP": "Georgetown, TX 78626",
   "ZIP CODE": 78626,
   "Latitude": 30.63312,
   "Longitude": -97.671086
 },
 {
   "ACCOUNT NAME": "Rock Liquor - Cedar Park",
   "DELIVERY ADDRESS": "2875 W WHITESTONE BLVD STE 140",
   "CITY, STATE, ZIP": "Cedar Park, TX 78613",
   "ZIP CODE": 78613,
   "Latitude": 30.515694,
   "Longitude": -97.87299
 },
 {
   "ACCOUNT NAME": "Salute Liquor",
   "DELIVERY ADDRESS": "105 E. Old Settlers Blvd #104",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.532909,
   "Longitude": -97.687039
 },
 {
   "ACCOUNT NAME": "Salute Liquor-Dripping Springs",
   "DELIVERY ADDRESS": "2400 West US 290 Suite 4",
   "CITY, STATE, ZIP": "Dripping Springs, TX 78620",
   "ZIP CODE": 78620,
   "Latitude": 30.206035,
   "Longitude": -98.123371
 },
 {
   "ACCOUNT NAME": "Sam's Liquor & Smoke Shop",
   "DELIVERY ADDRESS": "970 FM 967 Suite B",
   "CITY, STATE, ZIP": "Buda, TX 78610",
   "ZIP CODE": 78610,
   "Latitude": 30.093144,
   "Longitude": -97.848275
 },
 {
   "ACCOUNT NAME": "Siena Liquor & Smoke Shop",
   "DELIVERY ADDRESS": "51 Limmer Loop, Suite 200",
   "CITY, STATE, ZIP": "Round Rock, TX 78665",
   "ZIP CODE": 78665,
   "Latitude": 30.562687,
   "Longitude": -97.604956
 },
 {
   "ACCOUNT NAME": "Space Liquor",
   "DELIVERY ADDRESS": "30713 Chi Chi Dr.",
   "CITY, STATE, ZIP": "Georgetown, TX 78628",
   "ZIP CODE": 78628,
   "Latitude": 30.71584,
   "Longitude": -97.66382
 },
 {
   "ACCOUNT NAME": "Spec's Wholesale Austin - 296",
   "DELIVERY ADDRESS": "7900 Industry Way",
   "CITY, STATE, ZIP": "Austin, TX 78744",
   "ZIP CODE": 78744,
   "Latitude": 30.184093,
   "Longitude": -97.694036
 },
 {
   "ACCOUNT NAME": "Spec's, Arbor Walk - 62",
   "DELIVERY ADDRESS": "10515 N. Mopac Expwy",
   "CITY, STATE, ZIP": "Austin, TX 78759",
   "ZIP CODE": 78759,
   "Latitude": 30.391367,
   "Longitude": -97.733119
 },
 {
   "ACCOUNT NAME": "Spec's, Bee Cave - 65",
   "DELIVERY ADDRESS": "13015 Shops Pkwy",
   "CITY, STATE, ZIP": "Bee Cave, TX 78738",
   "ZIP CODE": 78738,
   "Latitude": 30.307598,
   "Longitude": -97.945921
 },
 {
   "ACCOUNT NAME": "Spec's, Brodie Lane - 61",
   "DELIVERY ADDRESS": "4970 West HWY 290",
   "CITY, STATE, ZIP": "Austin, TX 78735",
   "ZIP CODE": 78735,
   "Latitude": 30.198578,
   "Longitude": -98.179951
 },
 {
   "ACCOUNT NAME": "Spec's, Cedar Park - 179",
   "DELIVERY ADDRESS": "13530 Ronald Regan Blvd. #100",
   "CITY, STATE, ZIP": "Cedar Park, TX 78613",
   "ZIP CODE": 78613,
   "Latitude": 30.521326,
   "Longitude": -97.845691
 },
 {
   "ACCOUNT NAME": "Spec's, Four Points - 77",
   "DELIVERY ADDRESS": "10601 N. FM 620, Suite 107",
   "CITY, STATE, ZIP": "Austin, TX 78726",
   "ZIP CODE": 78726,
   "Latitude": 30.44422,
   "Longitude": -97.832146
 },
 {
   "ACCOUNT NAME": "Spec's, Galveston-35",
   "DELIVERY ADDRESS": "2711 61st Street",
   "CITY, STATE, ZIP": "Galveston, TX 77551",
   "ZIP CODE": 77551,
   "Latitude": 29.270921,
   "Longitude": -94.830851
 },
 {
   "ACCOUNT NAME": "Spec's, Georgetown - 95",
   "DELIVERY ADDRESS": "1013 W University Ave. #200",
   "CITY, STATE, ZIP": "Georgetown, TX 78628",
   "ZIP CODE": 78628,
   "Latitude": 30.631697,
   "Longitude": -97.694229
 },
 {
   "ACCOUNT NAME": "Spec's, High Meadow- 58",
   "DELIVERY ADDRESS": "12611 Hymeadow Dr.",
   "CITY, STATE, ZIP": "Austin, TX 78729",
   "ZIP CODE": 78729,
   "Latitude": 30.457857,
   "Longitude": -97.791437
 },
 {
   "ACCOUNT NAME": "Spec's, Highland Park - 60",
   "DELIVERY ADDRESS": "5775 Airport Blvd., Ste 100",
   "CITY, STATE, ZIP": "Austin, TX 78752",
   "ZIP CODE": 78752,
   "Latitude": 30.322312,
   "Longitude": -97.713799
 },
 {
   "ACCOUNT NAME": "Spec's, Killeen - 75",
   "DELIVERY ADDRESS": "2500 E. Central Texas Expy, Suite C",
   "CITY, STATE, ZIP": "Killeen, TX 76543",
   "ZIP CODE": 76543,
   "Latitude": 31.087861,
   "Longitude": -97.718715
 },
 {
   "ACCOUNT NAME": "Spec's, Lamar Street - 11",
   "DELIVERY ADDRESS": "914 N Lamar Blvd.",
   "CITY, STATE, ZIP": "Austin, TX 78703",
   "ZIP CODE": 78703,
   "Latitude": 30.274812,
   "Longitude": -97.752633
 },
 {
   "ACCOUNT NAME": "Spec's, Pflugerville -221",
   "DELIVERY ADDRESS": "19000 Limestone Commercial Dr.",
   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
   "ZIP CODE": 78660,
   "Latitude": 30.47182,
   "Longitude": -97.597129
 },
 {
   "ACCOUNT NAME": "Spec's, Round Rock - 63",
   "DELIVERY ADDRESS": "201 University Blvd, Suite 600",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.559134,
   "Longitude": -97.689197
 },
 {
   "ACCOUNT NAME": "Spec's , San Marcos-114",
   "DELIVERY ADDRESS": "510 Barnes Drive",
   "CITY, STATE, ZIP": "San Marcos, TX 78666",
   "ZIP CODE": 78666,
   "Latitude": 29.848518,
   "Longitude": -97.967677
 },
 {
   "ACCOUNT NAME": "Spec's, South Park Meadows - 64",
   "DELIVERY ADDRESS": "9900 S. IH35 Service",
   "CITY, STATE, ZIP": "Austin, TX 78748",
   "ZIP CODE": 78748,
   "Latitude": 30.202447,
   "Longitude": -97.760326
 },
 {
   "ACCOUNT NAME": "Spec's, Temple - 66",
   "DELIVERY ADDRESS": "3550 S. General Bruce Dr.",
   "CITY, STATE, ZIP": "Temple, TX 76504",
   "ZIP CODE": 76504,
   "Latitude": 31.094543,
   "Longitude": -97.382484
 },
 {
   "ACCOUNT NAME": "Stand Alone Liquor",
   "DELIVERY ADDRESS": "204 N Fort Hood St.",
   "CITY, STATE, ZIP": "Killeen, TX 76541",
   "ZIP CODE": 76541,
   "Latitude": 31.121916,
   "Longitude": -97.742186
 },
 {
   "ACCOUNT NAME": "Starbeam",
   "DELIVERY ADDRESS": "305 Sonny Drive Unit 100",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.568542,
   "Longitude": -97.852791
 },
 {
   "ACCOUNT NAME": "Starbeam Liquor #2",
   "DELIVERY ADDRESS": "6081 FM 1660 # 200",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "Latitude": 30.558859,
   "Longitude": -97.54377
 },
 {
   "ACCOUNT NAME": "Starbeam Liquor #1",
   "DELIVERY ADDRESS": "133 E. Front St. #200",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "Latitude": 30.542912,
   "Longitude": -97.542695
 },
 {
   "ACCOUNT NAME": "Starbeam Liquor #3",
   "DELIVERY ADDRESS": "13107 FM 969 Suite 200",
   "CITY, STATE, ZIP": "Austin, TX 78724",
   "ZIP CODE": 78724,
   "Latitude": 30.251683,
   "Longitude": -97.596627
 },
 {
   "ACCOUNT NAME": "Starbeam Liquor #6",
   "DELIVERY ADDRESS": "2300 Windy Hill Rd.",
   "CITY, STATE, ZIP": "Kyle, TX 78640",
   "ZIP CODE": 78640,
   "Latitude": 30.031827,
   "Longitude": -97.809584
 },
 {
   "ACCOUNT NAME": "Steiner Ranch Liquor",
   "DELIVERY ADDRESS": "5145 FM 620 North Suite L130",
   "CITY, STATE, ZIP": "Austin, TX 78732",
   "ZIP CODE": 78732,
   "Latitude": 30.389184,
   "Longitude": -97.883582
 },
 {
   "ACCOUNT NAME": "T Liquor",
   "DELIVERY ADDRESS": "2000 N Mays St. #300",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.528154,
   "Longitude": -97.688265
 },
 {
   "ACCOUNT NAME": "T Liquor 2",
   "DELIVERY ADDRESS": "120 Boselli Way",
   "CITY, STATE, ZIP": "Georgetown, TX 78626",
   "ZIP CODE": 78626,
   "Latitude": 30.57585,
   "Longitude": -97.685401
 },
 {
   "ACCOUNT NAME": "Temple Liquor & Smoke",
   "DELIVERY ADDRESS": "2204 W Avenue M, Suite A",
   "CITY, STATE, ZIP": "Temple, TX 76504",
   "ZIP CODE": 76504,
   "Latitude": 31.09082,
   "Longitude": -97.369082
 },
 {
   "ACCOUNT NAME": "Teravista Liquor",
   "DELIVERY ADDRESS": "2080 Westinghouse Road",
   "CITY, STATE, ZIP": "Georgetown, TX 78626",
   "ZIP CODE": 78626,
   "Latitude": 30.586841,
   "Longitude": -97.658535
 },
 {
   "ACCOUNT NAME": "Texas Star Liquor",
   "DELIVERY ADDRESS": "1949 Fire Cracker Dr. ste 100",
   "CITY, STATE, ZIP": "Buda, TX 78610",
   "ZIP CODE": 78610,
   "Latitude": 30.087897,
   "Longitude": -97.811395
 },
 {
   "ACCOUNT NAME": "Texas Star Liquor - Pflugerville",
   "DELIVERY ADDRESS": "18801 Weiss Lane,  Bldg. #2, Suite 200",
   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
   "ZIP CODE": 78660,
   "Latitude": 30.449488,
   "Longitude": -97.559741
 },
 {
   "ACCOUNT NAME": "The Austin Shaker - Pleasant Valley",
   "DELIVERY ADDRESS": "420 N. Pleasant Valley Rd. B",
   "CITY, STATE, ZIP": "Austin, TX 78702",
   "ZIP CODE": 78702,
   "Latitude": 30.256388,
   "Longitude": -97.711458
 },
 {
   "ACCOUNT NAME": "The Austin Shaker - Airport Blvd.",
   "DELIVERY ADDRESS": "1199 Airport Blvd.",
   "CITY, STATE, ZIP": "Austin, TX 78702",
   "ZIP CODE": 78702,
   "Latitude": 30.276511,
   "Longitude": -97.699722
 },
 {
   "ACCOUNT NAME": "The Austin Shaker - Oak Hill",
   "DELIVERY ADDRESS": "7626 HWY 71 W Suite 102",
   "CITY, STATE, ZIP": "Austin, TX 78735",
   "ZIP CODE": 78735,
   "Latitude": 30.217958,
   "Longitude": -97.690351
 },
 {
   "ACCOUNT NAME": "The Austin Shaker - US 183",
   "DELIVERY ADDRESS": "2500 S Hwy 183, Bldg 4 Suite 430",
   "CITY, STATE, ZIP": "Austin, TX 78744",
   "ZIP CODE": 78744,
   "Latitude": 30.210597,
   "Longitude": -97.683563
 },
 {
   "ACCOUNT NAME": "The Liquor Cabinet",
   "DELIVERY ADDRESS": "15301 Ronald Reagan Blvd Suite 11110",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.560101,
   "Longitude": -97.800099
 },
 {
   "ACCOUNT NAME": "Tipsy Liquor",
   "DELIVERY ADDRESS": "300 Hesters Crossing Rd. Suite A8",
   "CITY, STATE, ZIP": "Round Rock, TX 78681",
   "ZIP CODE": 78681,
   "Latitude": 30.488148,
   "Longitude": -97.679671
 },
 {
   "ACCOUNT NAME": "Top Barrel",
   "DELIVERY ADDRESS": "11620 Hero Way West",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "Latitude": 30.579244,
   "Longitude": -97.865895
 },
 {
   "ACCOUNT NAME": "Top Liquor",
   "DELIVERY ADDRESS": "1400 E. Old Settlers Blvd #108",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.539364,
   "Longitude": -97.670574
 },
 {
   "ACCOUNT NAME": "Travis Heights Wine and Spirits",
   "DELIVERY ADDRESS": "1948 S I-35 Frontage Road",
   "CITY, STATE, ZIP": "Austin, TX 78704",
   "ZIP CODE": 78704,
   "Latitude": 30.527353,
   "Longitude": -97.691338
 },
 {
   "ACCOUNT NAME": "Twin Liquors-Airport Road",
   "DELIVERY ADDRESS": "5639 Airport Blvd. Austin, TX 78751",
   "CITY, STATE, ZIP": "Austin, TX 78751",
   "ZIP CODE": 78751,
   "Latitude": 30.319021,
   "Longitude": -97.711309
 },
 {
   "ACCOUNT NAME": "Twin Liquors (Store 017)",
   "DELIVERY ADDRESS": "13497 Research Blvd",
   "CITY, STATE, ZIP": "Austin, TX 78750",
   "ZIP CODE": 78750,
   "Latitude": 30.437954,
   "Longitude": -97.776129
 },
 {
   "ACCOUNT NAME": "Twin Liquors - Palm Valley Blvd (048)",
   "DELIVERY ADDRESS": "1700 E Palm Valley Blvd, Suite 560",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.518991,
   "Longitude": -97.657699
 },
 {
   "ACCOUNT NAME": "Uptown Liquor #2  - Copperas Cove",
   "DELIVERY ADDRESS": "1202 US HWY 190",
   "CITY, STATE, ZIP": "Copperas Cove 76522",
   "ZIP CODE": 76522,
   "Latitude": 31.119883,
   "Longitude": -97.891562
 },
 {
   "ACCOUNT NAME": "Uptown Liquor #6* - Jarrell",
   "DELIVERY ADDRESS": "11840 N INTERSTATE 35",
   "CITY, STATE, ZIP": "Jarrell, TX 76537",
   "ZIP CODE": 76537,
   "Latitude": 30.814747,
   "Longitude": -97.610255
 },
 {
   "ACCOUNT NAME": "Uptown Liquor #5 - Jarrell",
   "DELIVERY ADDRESS": "181 TOWN CENTER BLVD STE 600",
   "CITY, STATE, ZIP": "Jarrell, TX 76537",
   "ZIP CODE": 76537,
   "Latitude": 30.817775,
   "Longitude": -97.615225
 },
 {
   "ACCOUNT NAME": "Uptown Liquor #7  - Manor",
   "DELIVERY ADDRESS": "11828 RING DR STE 107",
   "CITY, STATE, ZIP": "Manor, TX 78653",
   "ZIP CODE": 78653,
   "Latitude": 30.347674,
   "Longitude": -97.541132
 },
 {
   "ACCOUNT NAME": "Uptown Liquor #8 Austin",
   "DELIVERY ADDRESS": "1601 Ranch Road FM 2222 Suite F",
   "CITY, STATE, ZIP": "Austin, TX 78730",
   "ZIP CODE": 78730,
   "Latitude": 30.199154,
   "Longitude": -97.827685
 },
 {
   "ACCOUNT NAME": "Uptown Liquor #9 - Austin (MOPAC)",
   "DELIVERY ADDRESS": "14701 N MO PAC EXPY",
   "CITY, STATE, ZIP": "AUSTIN, TX 78728",
   "ZIP CODE": 78728,
   "Latitude": 30.472361,
   "Longitude": -97.702319
 },
 {
   "ACCOUNT NAME": "Uptown Liquor - Harker Heights",
   "DELIVERY ADDRESS": "300 W CENTRAL TEXAS EXPY STE 103",
   "CITY, STATE, ZIP": "Harker Heights, TX 76548",
   "ZIP CODE": 76548,
   "Latitude": 31.071145,
   "Longitude": -97.675623
 },
 {
   "ACCOUNT NAME": "Uptown Liquor - Liberty Hill",
   "DELIVERY ADDRESS": "14365 W STATE HIGHWAY 29 STE 4",
   "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
   "ZIP CODE": 78642,
   "Latitude": 30.672181,
   "Longitude": -97.920944
 },
 {
   "ACCOUNT NAME": "Urban Liquor",
   "DELIVERY ADDRESS": "11211 US Highway 290 E Suite 200B",
   "CITY, STATE, ZIP": "Manor, TX 78653",
   "ZIP CODE": 78653,
   "Latitude": 30.350823,
   "Longitude": -97.500362
 },
 {
   "ACCOUNT NAME": "V Liquors",
   "DELIVERY ADDRESS": "2800 E Palm Valley Blvd, Unit 140",
   "CITY, STATE, ZIP": "Round Rock, TX 78665",
   "ZIP CODE": 78665,
   "Latitude": 30.523181,
   "Longitude": -97.639635
 },
 {
   "ACCOUNT NAME": "West Campus Liquor",
   "DELIVERY ADDRESS": "709 W 22nd St. Ste 600",
   "CITY, STATE, ZIP": "Austin, TX 78705",
   "ZIP CODE": 78705,
   "Latitude": 30.284991,
   "Longitude": -97.745972
 },
 {
   "ACCOUNT NAME": "Nueces Liquor",
   "DELIVERY ADDRESS": " 2700 NUECES STREET #103",
   "CITY, STATE, ZIP": "Austin, TX 78705",
   "ZIP CODE": 78705,
   "Latitude": 30.292076,
   "Longitude": -97.743214
 },
 {
   "ACCOUNT NAME": "Whiskey Liquor - Hutto",
   "DELIVERY ADDRESS": "560 HIGHWAY 79 STE A800",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "Latitude": 30.542896,
   "Longitude": -97.556568
 },
 {
   "ACCOUNT NAME": "Wiggys Wine & Spirits",
   "DELIVERY ADDRESS": "1104 N Lamar Blvd",
   "CITY, STATE, ZIP": "Austin, TX 78703",
   "ZIP CODE": 78703,
   "Latitude": 30.276333,
   "Longitude": -97.751949
 },
 {
   "ACCOUNT NAME": "Wisky's Liquor #3 - Round Rock",
   "DELIVERY ADDRESS": "1350 E Palm Valley Blvd. Ste. #100",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "Latitude": 30.518278,
   "Longitude": -97.665324
 },
 {
   "ACCOUNT NAME": "Wwhisky's Liquor - Hudson Bend",
   "DELIVERY ADDRESS": "5000 Hudson Bend Rd. Unit F",
   "CITY, STATE, ZIP": "Austin, TX 78734",
   "ZIP CODE": 78734,
   "Latitude": 30.412007,
   "Longitude": -97.927237
 },
 {
   "ACCOUNT NAME": "Yeti Liquor",
   "DELIVERY ADDRESS": "2900 N Quinlan Park Rd Suite 110",
   "CITY, STATE, ZIP": "Austin, TX 78732",
   "ZIP CODE": 78732,
   "Latitude": 30.369178,
   "Longitude": -97.892631
 },
 {
   "ACCOUNT NAME": "Zeke's Liquor",
   "DELIVERY ADDRESS": "1711 E Cesar Chavez St. ste. D",
   "CITY, STATE, ZIP": "Austin, TX 78702",
   "ZIP CODE": 78702,
   "Latitude": 30.257378,
   "Longitude": -97.726049
 }

];
 
// [
//   {
//     "ACCOUNT NAME": "10th Street Liquor",
//     "DELIVERY ADDRESS": "1214 10th Street",
//     "CITY, STATE, ZIP": "Galveston, TX 77550",
//     "ZIP CODE": 77550,
//     "Latitude": "2.930.186",
//     "Longitude": "-94.776.182"
//   },
//   {
//     "ACCOUNT NAME": "21 Plus Liquor",
//     "DELIVERY ADDRESS": "10601 Ranch Road 2222 #F",
//     "CITY, STATE, ZIP": "Austin, TX 78730",
//     "ZIP CODE": 78730,
//     "Latitude": "30.393.089",
//     "Longitude": "-97.842.875"
//   },
//   {
//     "ACCOUNT NAME": "34 Wine and Spirits",
//     "DELIVERY ADDRESS": "4601 Southwest Pkwy #100",
//     "CITY, STATE, ZIP": "Austin, TX 78735",
//     "ZIP CODE": 78735,
//     "Latitude": "30.239.471",
//     "Longitude": "-97.831.814"
//   },
//   {
//     "ACCOUNT NAME": "512 Liquors",
//     "DELIVERY ADDRESS": "950 W University Ave Ste 205",
//     "CITY, STATE, ZIP": "Georgetown, TX 78626",
//     "ZIP CODE": 78626,
//     "Latitude": "30.632.577",
//     "Longitude": "-9.768.869"
//   },
//   {
//     "ACCOUNT NAME": "620 Liquor",
//     "DELIVERY ADDRESS": "17420 N FM 620 suite 130",
//     "CITY, STATE, ZIP": "Round Rock, TX 78681",
//     "ZIP CODE": 78681,
//     "Latitude": "30.415.529",
//     "Longitude": "-97.847.968"
//   },
//   {
//     "ACCOUNT NAME": "812 Liquor",
//     "DELIVERY ADDRESS": "105 Acuna Ct.",
//     "CITY, STATE, ZIP": "Del Valle, TX 78617",
//     "ZIP CODE": 78617,
//     "Latitude": "30.099.978",
//     "Longitude": "-97.604.999"
//   },
//   {
//     "ACCOUNT NAME": "AB Liquor",
//     "DELIVERY ADDRESS": "2036 US 183 #200",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "3.062.821",
//     "Longitude": "-97.866.085"
//   },
//   {
//     "ACCOUNT NAME": "AB Liquor #2 (Austin)",
//     "DELIVERY ADDRESS": "1809 W ANDERSON LN",
//     "CITY, STATE, ZIP": "Austin, TX 78757",
//     "ZIP CODE": 78757,
//     "Latitude": "30.353.303",
//     "Longitude": "-97.725.586"
//   },
//   {
//     "ACCOUNT NAME": "All Star Liquor",
//     "DELIVERY ADDRESS": "5725 Williams Dr. #120",
//     "CITY, STATE, ZIP": "Georgetown, TX 78633",
//     "ZIP CODE": 78633,
//     "Latitude": "30.703.808",
//     "Longitude": "-97.750.369"
//   },
//   {
//     "ACCOUNT NAME": "All Star Liquor - Leander Rd.",
//     "DELIVERY ADDRESS": "1011 LEANDER RD STE 102",
//     "CITY, STATE, ZIP": "Georgetown, TX 78628",
//     "ZIP CODE": 78628,
//     "Latitude": 306.202,
//     "Longitude": "-97.691.892"
//   },
//   {
//     "ACCOUNT NAME": "All Star Liquor - Taylor",
//     "DELIVERY ADDRESS": "3100 N MAIN ST STE 127",
//     "CITY, STATE, ZIP": "Taylor, TX 76574",
//     "ZIP CODE": 76574,
//     "Latitude": "30.594.795",
//     "Longitude": "-97.412.476"
//   },
//   {
//     "ACCOUNT NAME": "All Star Liquor - Temple",
//     "DELIVERY ADDRESS": "2934 S 31ST ST",
//     "CITY, STATE, ZIP": "Temple, TX 76502",
//     "ZIP CODE": 76502,
//     "Latitude": "31.071.982",
//     "Longitude": "-9.736.945"
//   },
//   {
//     "ACCOUNT NAME": "Alma's Liquor",
//     "DELIVERY ADDRESS": "3920 Williams Drive Suite 202",
//     "CITY, STATE, ZIP": "Georgetown, TX 78628",
//     "ZIP CODE": 78628,
//     "Latitude": "30.673.918",
//     "Longitude": "-9.770.336"
//   },
//   {
//     "ACCOUNT NAME": "Andy's Liquors",
//     "DELIVERY ADDRESS": "9616 N Lamar Blvd",
//     "CITY, STATE, ZIP": "Austin, TX 78753",
//     "ZIP CODE": 78753,
//     "Latitude": "30.366.803",
//     "Longitude": "-97.695.605"
//   },
//   {
//     "ACCOUNT NAME": "Avery Ranch Wine & Spirits",
//     "DELIVERY ADDRESS": "10510 W Parmer Lane # 118",
//     "CITY, STATE, ZIP": "Austin, TX 78717",
//     "ZIP CODE": 78717,
//     "Latitude": "30.496.498",
//     "Longitude": "-97.774.191"
//   },
//   {
//     "ACCOUNT NAME": "Awesome Liquors",
//     "DELIVERY ADDRESS": "2418 RR 620 S #200",
//     "CITY, STATE, ZIP": "Lakeway, TX 78738",
//     "ZIP CODE": 78738,
//     "Latitude": "30.392.441",
//     "Longitude": "-97.876.748"
//   },
//   {
//     "ACCOUNT NAME": "Bastrop Liquor & Smoke Shop",
//     "DELIVERY ADDRESS": "103 State Hwy 71W",
//     "CITY, STATE, ZIP": "Bastrop, TX",
//     "ZIP CODE": 78602,
//     "Latitude": "30.103.704",
//     "Longitude": "-97.321.031"
//   },
//   {
//     "ACCOUNT NAME": "BB LIQUOR",
//     "DELIVERY ADDRESS": "4435 N STATE HIGHWAY 123 STE 206",
//     "CITY, STATE, ZIP": "San Marcos, TX 78666",
//     "ZIP CODE": 78666,
//     "Latitude": "29.806.874",
//     "Longitude": "-97.944.457"
//   },
//   {
//     "ACCOUNT NAME": "BB Liquor 2",
//     "DELIVERY ADDRESS": "1050 Bunton Creek Road Suite 170",
//     "CITY, STATE, ZIP": "Kyle, TX 78640",
//     "ZIP CODE": 78640,
//     "Latitude": "30.004.203",
//     "Longitude": "-97.856.317"
//   },
//   {
//     "ACCOUNT NAME": "Bergheim Cellars",
//     "DELIVERY ADDRESS": "1 FM 3351",
//     "CITY, STATE, ZIP": "Boerne, TX 78006",
//     "ZIP CODE": 78006,
//     "Latitude": "29.825.873",
//     "Longitude": "-98.573.107"
//   },
//   {
//     "ACCOUNT NAME": "Beverage Delite Liquor Store",
//     "DELIVERY ADDRESS": "6565 Babcock Rd #18",
//     "CITY, STATE, ZIP": "San Antonio, TX 78249",
//     "ZIP CODE": 78249,
//     "Latitude": "29.555.792",
//     "Longitude": "-98.614.476"
//   },
//   {
//     "ACCOUNT NAME": "Blackhawk Liquor",
//     "DELIVERY ADDRESS": "20205 FM 685",
//     "CITY, STATE, ZIP": "Pflugerville, TX 78660",
//     "ZIP CODE": 78660,
//     "Latitude": "30.484.083",
//     "Longitude": "-97.583.866"
//   },
//   {
//     "ACCOUNT NAME": "Boggy's Liquor",
//     "DELIVERY ADDRESS": "4712 Lohman Ford Rd. Ste. 200",
//     "CITY, STATE, ZIP": "Lago Vista, TX 78645",
//     "ZIP CODE": 78645,
//     "Latitude": "30.434.303",
//     "Longitude": "-97.978.575"
//   },
//   {
//     "ACCOUNT NAME": "Buda Liquor",
//     "DELIVERY ADDRESS": "17020 S I-35 Frontage Rd Suite A1-B1",
//     "CITY, STATE, ZIP": "Buda, TX 78610",
//     "ZIP CODE": 78610,
//     "Latitude": "30.060.784",
//     "Longitude": "-97.834.261"
//   },
//   {
//     "ACCOUNT NAME": "Castle Liquor",
//     "DELIVERY ADDRESS": "1290 Bebee Rd. #300",
//     "CITY, STATE, ZIP": "Kyle, TX 78640",
//     "ZIP CODE": 78640,
//     "Latitude": "30.018.843",
//     "Longitude": "-97.842.491"
//   },
//   {
//     "ACCOUNT NAME": "Cedar Liquor",
//     "DELIVERY ADDRESS": "729 E. Slaughter Ln. Ste, B",
//     "CITY, STATE, ZIP": "Austin, TX 78744",
//     "ZIP CODE": 78744,
//     "Latitude": "30.160.339",
//     "Longitude": "-97.777.125"
//   },
//   {
//     "ACCOUNT NAME": "Cedar Liquor #2",
//     "DELIVERY ADDRESS": "729 E SLAUGHTER LN STE B AUSTIN, TX 78744",
//     "CITY, STATE, ZIP": "Austin, TX 78725",
//     "ZIP CODE": 78725,
//     "Latitude": "30.160.339",
//     "Longitude": "-97.777.125"
//   },
//   {
//     "ACCOUNT NAME": "Cedar Valley Liquor",
//     "DELIVERY ADDRESS": "12002 W Hwy 290",
//     "CITY, STATE, ZIP": "Austin, TX 78737",
//     "ZIP CODE": 78737,
//     "Latitude": "30.211.522",
//     "Longitude": "-9.796.897"
//   },
//   {
//     "ACCOUNT NAME": "Cedar Valley Spirits",
//     "DELIVERY ADDRESS": "12002 US-290",
//     "CITY, STATE, ZIP": "Austin, TX 78737",
//     "ZIP CODE": 78737,
//     "Latitude": "30.234.388",
//     "Longitude": "-97.911.837"
//   },
//   {
//     "ACCOUNT NAME": "Chris' Liquor 3",
//     "DELIVERY ADDRESS": "6800 West Gate Blvd",
//     "CITY, STATE, ZIP": "Austin, TX 78745",
//     "ZIP CODE": 78745,
//     "Latitude": "3.020.917",
//     "Longitude": "-97.815.907"
//   },
//   {
//     "ACCOUNT NAME": "Chris' Liquor Stores",
//     "DELIVERY ADDRESS": "2203 S Lamar Blvd.",
//     "CITY, STATE, ZIP": "Austin, TX 78704",
//     "ZIP CODE": 78704,
//     "Latitude": "30.247.298",
//     "Longitude": "-97.773.228"
//   },
//   {
//     "ACCOUNT NAME": "Circle B Liquor",
//     "DELIVERY ADDRESS": "1108 FM 1431",
//     "CITY, STATE, ZIP": "Marble Falls, TX 78654",
//     "ZIP CODE": 78654,
//     "Latitude": "30.579.588",
//     "Longitude": "-98.276.148"
//   },
//   {
//     "ACCOUNT NAME": "Clint's Liquor #10",
//     "DELIVERY ADDRESS": "3651 N US HWY 183 #160",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "30.705.279",
//     "Longitude": "-97.875.695"
//   },
//   {
//     "ACCOUNT NAME": "Clint's Liquor #7",
//     "DELIVERY ADDRESS": "940 Westinghouse Rd. #100",
//     "CITY, STATE, ZIP": "Georgetown, TX 78626",
//     "ZIP CODE": 78626,
//     "Latitude": "30.581.431",
//     "Longitude": "-97.676.291"
//   },
//   {
//     "ACCOUNT NAME": "Clint's Liquor #8",
//     "DELIVERY ADDRESS": "12518 Research Blvd. # H",
//     "CITY, STATE, ZIP": "Austin, TX 78759",
//     "ZIP CODE": 78759,
//     "Latitude": "30.431.179",
//     "Longitude": "-97.764.562"
//   },
//   {
//     "ACCOUNT NAME": "Clint's Liquors #4",
//     "DELIVERY ADDRESS": "16009 FM 1325 Suite 204",
//     "CITY, STATE, ZIP": "Austin, TX 78728",
//     "ZIP CODE": 78728,
//     "Latitude": "30.471.438",
//     "Longitude": "-97.690.971"
//   },
//   {
//     "ACCOUNT NAME": "Clint's Liquor #3",
//     "DELIVERY ADDRESS": "195 S HASLER BLVD STE A",
//     "CITY, STATE, ZIP": "Bastrop,TX 78602",
//     "ZIP CODE": 78602,
//     "Latitude": "30.105.775",
//     "Longitude": "-97.335.375"
//   },
//   {
//     "ACCOUNT NAME": "Clint's Liquor #5",
//     "DELIVERY ADDRESS": "211 W HIGHWAY 79",
//     "CITY, STATE, ZIP": "THRALL, TX 76578",
//     "ZIP CODE": 76578,
//     "Latitude": "30.591.152",
//     "Longitude": "-97.301.382"
//   },
//   {
//     "ACCOUNT NAME": "King's Liquor",
//     "DELIVERY ADDRESS": "619 N MAIN ST",
//     "CITY, STATE, ZIP": "Taylor, TX 76574",
//     "ZIP CODE": 76574,
//     "Latitude": "3.057.323",
//     "Longitude": "-97.410.345"
//   },
//   {
//     "ACCOUNT NAME": "Cold Springs Liquor",
//     "DELIVERY ADDRESS": "15609 Ronald Reagan Blvd. Suite B-100",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "30.564.032",
//     "Longitude": "-97.801.166"
//   },
//   {
//     "ACCOUNT NAME": "Cold Springs Liquor Liberty Hill",
//     "DELIVERY ADDRESS": "9073 W State HWY 29 STE 112",
//     "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
//     "ZIP CODE": 78642,
//     "Latitude": "30.641.738",
//     "Longitude": "-97.840.343"
//   },
//   {
//     "ACCOUNT NAME": "Country Life Wine & Spirits",
//     "DELIVERY ADDRESS": "4520 Farm to Market 1626 Suite 200",
//     "CITY, STATE, ZIP": "Kyle, TX 78640",
//     "ZIP CODE": 78640,
//     "Latitude": "30.023.392",
//     "Longitude": "-97.872.945"
//   },
//   {
//     "ACCOUNT NAME": "Country Life Wine & Spirits #2",
//     "DELIVERY ADDRESS": "8947 FM 2244 RD STE 206",
//     "CITY, STATE, ZIP": "Austin, TX 78746",
//     "ZIP CODE": 78746,
//     "Latitude": "30.317.581",
//     "Longitude": "-97.863.684"
//   },
//   {
//     "ACCOUNT NAME": "Crowne Liquor",
//     "DELIVERY ADDRESS": "2211 TX-46 STE 102",
//     "CITY, STATE, ZIP": "New Braunfels, TX 78130",
//     "ZIP CODE": 78130,
//     "Latitude": "29.663.741",
//     "Longitude": "-98.049.878"
//   },
//   {
//     "ACCOUNT NAME": "Dany's Liquor",
//     "DELIVERY ADDRESS": "2700 West Pecan Street",
//     "CITY, STATE, ZIP": "Pflugerville, TX 78660",
//     "ZIP CODE": 78660,
//     "Latitude": "30.450.026",
//     "Longitude": "-97.656.574"
//   },
//   {
//     "ACCOUNT NAME": "Deb's Liquor",
//     "DELIVERY ADDRESS": "10740 Research Blvd. #135",
//     "CITY, STATE, ZIP": "Austin, TX 78759",
//     "ZIP CODE": 78759,
//     "Latitude": "30.396.691",
//     "Longitude": "-97.745.609"
//   },
//   {
//     "ACCOUNT NAME": "Don's Liquor",
//     "DELIVERY ADDRESS": "100 E Whitestone Blvd #140",
//     "CITY, STATE, ZIP": "Cedar Park, TX 78613",
//     "ZIP CODE": 78613,
//     "Latitude": "30.522.173",
//     "Longitude": "-97.830.196"
//   },
//   {
//     "ACCOUNT NAME": "Don's Liquor #2 - Leander",
//     "DELIVERY ADDRESS": "12681 Hero Way Suite B",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "30.573.215",
//     "Longitude": "-97.881.709"
//   },
//   {
//     "ACCOUNT NAME": "Don's Liquor 183",
//     "DELIVERY ADDRESS": "2403 S Hwy 183 #101",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "30.547.243",
//     "Longitude": "-97.842.107"
//   },
//   {
//     "ACCOUNT NAME": "Don's Liquor Wells Branch",
//     "DELIVERY ADDRESS": "3407 Wells Branch Pkwy",
//     "CITY, STATE, ZIP": "Austin, TX 78728",
//     "ZIP CODE": 78728,
//     "Latitude": "30.439.784",
//     "Longitude": "-97.697.077"
//   },
//   {
//     "ACCOUNT NAME": "East Village Liquor",
//     "DELIVERY ADDRESS": "3500 E. Parmer Lane Suite 2142",
//     "CITY, STATE, ZIP": "Austin, TX 78754",
//     "ZIP CODE": 78754,
//     "Latitude": "30.376.107",
//     "Longitude": "-97.629.812"
//   },
//   {
//     "ACCOUNT NAME": "Economy Liquor",
//     "DELIVERY ADDRESS": "1911 23rd Street",
//     "CITY, STATE, ZIP": "Galveston, TX 77550",
//     "ZIP CODE": 77550,
//     "Latitude": "29.291.993",
//     "Longitude": "-94.789.054"
//   },
//   {
//     "ACCOUNT NAME": "Everest Liquor",
//     "DELIVERY ADDRESS": "1900 University Boulevard #140",
//     "CITY, STATE, ZIP": "Round Rock, TX 78665",
//     "ZIP CODE": 78665,
//     "Latitude": "30.572.311",
//     "Longitude": "-97.653.305"
//   },
//   {
//     "ACCOUNT NAME": "Fion Liquor",
//     "DELIVERY ADDRESS": "1200 Lakeway Dr #14",
//     "CITY, STATE, ZIP": "Lakeway, TX 78734",
//     "ZIP CODE": 78734,
//     "Latitude": "30.363.594",
//     "Longitude": "-97.981.605"
//   },
//   {
//     "ACCOUNT NAME": "Freedom Libations",
//     "DELIVERY ADDRESS": "15050 W State Hwy 29 ste 180",
//     "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
//     "ZIP CODE": 78642,
//     "Latitude": "3.067.536",
//     "Longitude": "-97.931.384"
//   },
//   {
//     "ACCOUNT NAME": "Freedom Libations-Round Rock",
//     "DELIVERY ADDRESS": "2800 E. Palm Valley Blvd Suite 140",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.523.181",
//     "Longitude": "-97.639.635"
//   },
//   {
//     "ACCOUNT NAME": "Friday Night Liquors",
//     "DELIVERY ADDRESS": "409 W Front St STE 130",
//     "CITY, STATE, ZIP": "Hutto, TX 78634",
//     "ZIP CODE": 78634,
//     "Latitude": "30.541.322",
//     "Longitude": "-9.754.897"
//   },
//   {
//     "ACCOUNT NAME": "Galaxy Liquors",
//     "DELIVERY ADDRESS": "2030 E Oltorf St. ste 112",
//     "CITY, STATE, ZIP": "Austin, TX 78741",
//     "ZIP CODE": 78741,
//     "Latitude": "30.230.786",
//     "Longitude": "-97.732.156"
//   },
//   {
//     "ACCOUNT NAME": "Galveston Liquor",
//     "DELIVERY ADDRESS": "4613 Fort Crockett Blvd",
//     "CITY, STATE, ZIP": "Galveston, TX 77551",
//     "ZIP CODE": 77551,
//     "Latitude": "29.275.613",
//     "Longitude": "-94.812.526"
//   },
//   {
//     "ACCOUNT NAME": "Geek Liquor",
//     "DELIVERY ADDRESS": "2051 W. FM 1626 ste B",
//     "CITY, STATE, ZIP": "Manchaca, TX 78652",
//     "ZIP CODE": 78652,
//     "Latitude": "30.139.349",
//     "Longitude": "-97.847.119"
//   },
//   {
//     "ACCOUNT NAME": "Georgetown Liquor",
//     "DELIVERY ADDRESS": "1202 S Main St.",
//     "CITY, STATE, ZIP": "Georgetown, TX 78626",
//     "ZIP CODE": 78626,
//     "Latitude": "30.633.057",
//     "Longitude": "-97.677.401"
//   },
//   {
//     "ACCOUNT NAME": "Gunter's Liquor",
//     "DELIVERY ADDRESS": "11150 Research Blvd Suite 103B",
//     "CITY, STATE, ZIP": "Austin, TX 78759",
//     "ZIP CODE": 78759,
//     "Latitude": "30.403.956",
//     "Longitude": "-97.746.099"
//   },
//   {
//     "ACCOUNT NAME": "Hall's Liquor",
//     "DELIVERY ADDRESS": "2121 45th Street",
//     "CITY, STATE, ZIP": "Galveston, TX 77550",
//     "ZIP CODE": 77550,
//     "Latitude": "29.283.128",
//     "Longitude": "-9.481.389"
//   },
//   {
//     "ACCOUNT NAME": "Happy Hill Country Liquor",
//     "DELIVERY ADDRESS": "719 US-183 Suite B-102",
//     "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
//     "ZIP CODE": 78642,
//     "Latitude": "3.064.275",
//     "Longitude": "-97.870.377"
//   },
//   {
//     "ACCOUNT NAME": "Happy Town Liquor",
//     "DELIVERY ADDRESS": "1552 FM 685 #105",
//     "CITY, STATE, ZIP": "Pflugerville, TX 78660",
//     "ZIP CODE": 78660,
//     "Latitude": "30.453.065",
//     "Longitude": "-97.604.304"
//   },
//   {
//     "ACCOUNT NAME": "Hippo Liquor Stop",
//     "DELIVERY ADDRESS": "3333 CR 119 Suite 6",
//     "CITY, STATE, ZIP": "Hutto, TX 78634",
//     "ZIP CODE": 78634,
//     "Latitude": "30.580.907",
//     "Longitude": "-97.571.743"
//   },
//   {
//     "ACCOUNT NAME": "Hoekstra Bros.",
//     "DELIVERY ADDRESS": "9408 E HWY 71 Unit  A",
//     "CITY, STATE, ZIP": "Spicewood, TX 78669",
//     "ZIP CODE": 78669,
//     "Latitude": "30.462.452",
//     "Longitude": -981.604
//   },
//   {
//     "ACCOUNT NAME": "Hutto Liquor",
//     "DELIVERY ADDRESS": "525 Chris Kelley Blvd Unit 2",
//     "CITY, STATE, ZIP": "Hutto, TX 78634",
//     "ZIP CODE": 78634,
//     "Latitude": "3.053.227",
//     "Longitude": "-97.563.677"
//   },
//   {
//     "ACCOUNT NAME": "Jacob's Liquor",
//     "DELIVERY ADDRESS": "11410 Menchaca Rd  #300",
//     "CITY, STATE, ZIP": "Austin, TX 78748",
//     "ZIP CODE": 78748,
//     "Latitude": "30.154.195",
//     "Longitude": "-97.833.752"
//   },
//   {
//     "ACCOUNT NAME": "JC Liquors",
//     "DELIVERY ADDRESS": "100 US Highway 281 N.",
//     "CITY, STATE, ZIP": "Johnson City, TX 78636",
//     "ZIP CODE": 78636,
//     "Latitude": "30.278.182",
//     "Longitude": "-98.404.469"
//   },
//   {
//     "ACCOUNT NAME": "Jenn's Beer, Wine & Spirits",
//     "DELIVERY ADDRESS": "1210 Madrid St",
//     "CITY, STATE, ZIP": "Castroville, TX 78009",
//     "ZIP CODE": 78009,
//     "Latitude": "29.351.498",
//     "Longitude": "-98.885.387"
//   },
//   {
//     "ACCOUNT NAME": "JJ Liquor",
//     "DELIVERY ADDRESS": "30070 US-281 #218",
//     "CITY, STATE, ZIP": "Bulverde, TX 78163",
//     "ZIP CODE": 78163,
//     "Latitude": "29.741.272",
//     "Longitude": "-98.435.354"
//   },
//   {
//     "ACCOUNT NAME": "JJ Liquor 3",
//     "DELIVERY ADDRESS": "1 FM 3351 S STE 150",
//     "CITY, STATE, ZIP": "Boerne, TX 78006",
//     "ZIP CODE": 78006,
//     "Latitude": "29.825.873",
//     "Longitude": "-98.573.107"
//   },
//   {
//     "ACCOUNT NAME": "Johnnie's Liquor Store",
//     "DELIVERY ADDRESS": "13201 Pond Springs Rd. Ste 203",
//     "CITY, STATE, ZIP": "Austin, TX 78729",
//     "ZIP CODE": 78729,
//     "Latitude": "30.445.399",
//     "Longitude": "-97.778.201"
//   },
//   {
//     "ACCOUNT NAME": "King Liquor",
//     "DELIVERY ADDRESS": "5310 Burnet Road #100",
//     "CITY, STATE, ZIP": "Austin, TX 78756",
//     "ZIP CODE": 78756,
//     "Latitude": "30.327.056",
//     "Longitude": "-97.740.583"
//   },
//   {
//     "ACCOUNT NAME": "King Liquor (Georgetown)",
//     "DELIVERY ADDRESS": "221 FM 971 ste. #102",
//     "CITY, STATE, ZIP": "Georgetown, TX 78626",
//     "ZIP CODE": 78626,
//     "Latitude": "30.656.134",
//     "Longitude": "-97.666.322"
//   },
//   {
//     "ACCOUNT NAME": "King Liquor 2 (Georgetown - Williams)",
//     "DELIVERY ADDRESS": "3010 WILLIAMS DR STE 123",
//     "CITY, STATE, ZIP": "Georgetown, TX 78628",
//     "ZIP CODE": 78628,
//     "Latitude": "30.662.578",
//     "Longitude": "-97.693.281"
//   },
//   {
//     "ACCOUNT NAME": "King Liquor-San Antonio",
//     "DELIVERY ADDRESS": "20711 Wilderness Oak Suite 112",
//     "CITY, STATE, ZIP": "San Antonio, TX 78258",
//     "ZIP CODE": 78258,
//     "Latitude": "29.635.119",
//     "Longitude": "-98.516.508"
//   },
//   {
//     "ACCOUNT NAME": "Lafitte's Liquor & Fine Wine LLC",
//     "DELIVERY ADDRESS": "18601 Ranch Rd 1431 Ste 101",
//     "CITY, STATE, ZIP": "Jonestown, TX 78645",
//     "ZIP CODE": 78645,
//     "Latitude": "30.595.536",
//     "Longitude": "-97.990.082"
//   },
//   {
//     "ACCOUNT NAME": "Lakeside Liquor",
//     "DELIVERY ADDRESS": "3390 18100, FM306 Suite 130",
//     "CITY, STATE, ZIP": "Canyon Lake, TX 78133",
//     "ZIP CODE": 78133,
//     "Latitude": "2.991.366",
//     "Longitude": "-98.214.182"
//   },
//   {
//     "ACCOUNT NAME": "Lakeside Liquors 1",
//     "DELIVERY ADDRESS": "11725 W Adams Ave.",
//     "CITY, STATE, ZIP": "Temple, TX 76513",
//     "ZIP CODE": 76513,
//     "Latitude": "31.128.424",
//     "Longitude": "-97.467.864"
//   },
//   {
//     "ACCOUNT NAME": "Lakeside Wine and Spirits",
//     "DELIVERY ADDRESS": "7708 Lohman Ford Road Suite D101",
//     "CITY, STATE, ZIP": "Lago Vista, TX 78645",
//     "ZIP CODE": 78645,
//     "Latitude": "30.472.869",
//     "Longitude": -979.766
//   },
//   {
//     "ACCOUNT NAME": "Liquor 29",
//     "DELIVERY ADDRESS": "9073 W State Hwy 29 UNIT 112",
//     "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
//     "ZIP CODE": 78642,
//     "Latitude": "30.641.738",
//     "Longitude": "-97.840.343"
//   },
//   {
//     "ACCOUNT NAME": "Liquor Store",
//     "DELIVERY ADDRESS": "102 E Hallmark Avenue",
//     "CITY, STATE, ZIP": "Killeen, TX 76541",
//     "ZIP CODE": 76541,
//     "Latitude": "31.112.324",
//     "Longitude": "-9.773.306"
//   },
//   {
//     "ACCOUNT NAME": "Liquor Xpress",
//     "DELIVERY ADDRESS": "1093 N Hwy 95 Suite 102",
//     "CITY, STATE, ZIP": "Bastrop, TX 78602",
//     "ZIP CODE": 78602,
//     "Latitude": "30.175.468",
//     "Longitude": "-97.315.693"
//   },
//   {
//     "ACCOUNT NAME": "Lone Star Spirits",
//     "DELIVERY ADDRESS": "14150 US-281 Unit B",
//     "CITY, STATE, ZIP": "Spring Branch, TX 78070",
//     "ZIP CODE": 78070,
//     "Latitude": "29.933.521",
//     "Longitude": "-98.412.183"
//   },
//   {
//     "ACCOUNT NAME": "LoneStar Elite Liquor",
//     "DELIVERY ADDRESS": "5725 WILLIAMS DR STE 120",
//     "CITY, STATE, ZIP": "Georgetown, TX 78633",
//     "ZIP CODE": 78633,
//     "Latitude": "30.703.808",
//     "Longitude": "-97.750.369"
//   },
//   {
//     "ACCOUNT NAME": "Long Branch Liquor",
//     "DELIVERY ADDRESS": "4201 E Rancier Ave #109",
//     "CITY, STATE, ZIP": "Killeen, TX 76543",
//     "ZIP CODE": 76543,
//     "Latitude": "3.111.643",
//     "Longitude": "-97.683.168"
//   },
//   {
//     "ACCOUNT NAME": "M & R Liquors",
//     "DELIVERY ADDRESS": "13133 - B LOUETTA RD",
//     "CITY, STATE, ZIP": "CYPRESS, TX 77429",
//     "ZIP CODE": 77429,
//     "Latitude": "29.995.028",
//     "Longitude": "-95.621.159"
//   },
//   {
//     "ACCOUNT NAME": "Mad Rooster's - Dripping Springs",
//     "DELIVERY ADDRESS": "31560 RANCH ROAD 12 UNIT 206",
//     "CITY, STATE, ZIP": "Dripping Springs, TX 78620",
//     "ZIP CODE": 78620,
//     "Latitude": "30.207.521",
//     "Longitude": "-98.087.774"
//   },
//   {
//     "ACCOUNT NAME": "Mad Rooster's - Wimberley",
//     "DELIVERY ADDRESS": "111 OLD KYLE RD STE 310",
//     "CITY, STATE, ZIP": "Wimberley, TX 78676",
//     "ZIP CODE": 78676,
//     "Latitude": "29.996.918",
//     "Longitude": "-98.095.381"
//   },
//   {
//     "ACCOUNT NAME": "Mad Rooster's Warehouse",
//     "DELIVERY ADDRESS": "6601 FM 3237 STE 105",
//     "CITY, STATE, ZIP": "Wimberley, TX 78676",
//     "ZIP CODE": 78676,
//     "Latitude": "30.035.042",
//     "Longitude": "-98.034.229"
//   },
//   {
//     "ACCOUNT NAME": "Monarch Liquor",
//     "DELIVERY ADDRESS": "1902 E. Martin Luther King Jr. Blvd. Suite A",
//     "CITY, STATE, ZIP": "Austin, TX 78702",
//     "ZIP CODE": 78702,
//     "Latitude": "30.280.111",
//     "Longitude": "-9.772.082"
//   },
//   {
//     "ACCOUNT NAME": "Monarch Liquor II",
//     "DELIVERY ADDRESS": "1700 RANCH ROAD 620 N STE 107B",
//     "CITY, STATE, ZIP": "Lakeway, TX 78734",
//     "ZIP CODE": 78734,
//     "Latitude": "30.345.959",
//     "Longitude": "-97.965.157"
//   },
//   {
//     "ACCOUNT NAME": "Moon Dance Spirits & Wine",
//     "DELIVERY ADDRESS": "3720 Gattis School Rd. ste. #900",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.498.817",
//     "Longitude": "-97.615.579"
//   },
//   {
//     "ACCOUNT NAME": "Brodie's Liquor",
//     "DELIVERY ADDRESS": "7612 BRODIE LN STE B",
//     "CITY, STATE, ZIP": "Austin, TX 78745",
//     "ZIP CODE": 78745,
//     "Latitude": "30.206.995",
//     "Longitude": "-97.835.244"
//   },
//   {
//     "ACCOUNT NAME": "Liquor Xpress #2",
//     "DELIVERY ADDRESS": "14815 DESSAU RD STE 200",
//     "CITY, STATE, ZIP": "Pflugerville, TX 78660",
//     "ZIP CODE": 78660,
//     "Latitude": "30.420.349",
//     "Longitude": "-97.628.118"
//   },
//   {
//     "ACCOUNT NAME": "Z's Liquor",
//     "DELIVERY ADDRESS": "14509 FM 969 UNIT 101",
//     "CITY, STATE, ZIP": "Austin, TX 78724",
//     "ZIP CODE": 78724,
//     "Latitude": "30.247.738",
//     "Longitude": "-97.583.676"
//   },
//   {
//     "ACCOUNT NAME": "My Choice Liquor",
//     "DELIVERY ADDRESS": "1601 S Interstate 35 #390",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.494.412",
//     "Longitude": "-97.676.765"
//   },
//   {
//     "ACCOUNT NAME": "Near Me Liquor",
//     "DELIVERY ADDRESS": "11521 N FM 620, STE 300",
//     "CITY, STATE, ZIP": "Austin, TX 78726",
//     "ZIP CODE": 78726,
//     "Latitude": "30.454.661",
//     "Longitude": "-97.825.896"
//   },
//   {
//     "ACCOUNT NAME": "New Lago Liquor",
//     "DELIVERY ADDRESS": "6015 Lohman Ford Road",
//     "CITY, STATE, ZIP": "Lago Vista, TX 78645",
//     "ZIP CODE": 78645,
//     "Latitude": "30.450.413",
//     "Longitude": "-9.797.869"
//   },
//   {
//     "ACCOUNT NAME": "Nic's Liquor",
//     "DELIVERY ADDRESS": "13225 George Bush Street",
//     "CITY, STATE, ZIP": "Manor, TX 78653",
//     "ZIP CODE": 78653,
//     "Latitude": "30.351.091",
//     "Longitude": "-97.527.009"
//   },
//   {
//     "ACCOUNT NAME": "Oak N Vine Liquor",
//     "DELIVERY ADDRESS": "601 W New Hope Dr Suite 105",
//     "CITY, STATE, ZIP": "Cedar Park , TX 78613",
//     "ZIP CODE": 78613,
//     "Latitude": "30.531.182",
//     "Longitude": "-97.842.332"
//   },
//   {
//     "ACCOUNT NAME": "Old School Liquor & Market",
//     "DELIVERY ADDRESS": "1901 W William Cannon Dr Suite 165B",
//     "CITY, STATE, ZIP": "Austin, TX 78745",
//     "ZIP CODE": 78745,
//     "Latitude": "30.201.885",
//     "Longitude": "-97.805.059"
//   },
//   {
//     "ACCOUNT NAME": "Oliver's Southern Spirits",
//     "DELIVERY ADDRESS": "205 TX-7",
//     "CITY, STATE, ZIP": "Eddy, TX 76524",
//     "ZIP CODE": 76524,
//     "Latitude": "31.290.746",
//     "Longitude": "-97.240.839"
//   },
//   {
//     "ACCOUNT NAME": "One Stop Liquor",
//     "DELIVERY ADDRESS": "12135 Potranco Rd",
//     "CITY, STATE, ZIP": "San Antonio, TX 78253",
//     "ZIP CODE": 78253,
//     "Latitude": "29.431.932",
//     "Longitude": "-9.873.284"
//   },
//   {
//     "ACCOUNT NAME": "Palm Valley Liquors",
//     "DELIVERY ADDRESS": "4500 E. Palm Valley Blvd. Suite 114",
//     "CITY, STATE, ZIP": "Round Rock, TX 78665",
//     "ZIP CODE": 78665,
//     "Latitude": "30.533.019",
//     "Longitude": "-97.616.292"
//   },
//   {
//     "ACCOUNT NAME": "PK Operators",
//     "DELIVERY ADDRESS": "302 Sam Houston Drive",
//     "CITY, STATE, ZIP": "Victoria, TX 77901",
//     "ZIP CODE": 77901,
//     "Latitude": "28.817.751",
//     "Longitude": "-9.696.841"
//   },
//   {
//     "ACCOUNT NAME": "Pojo's Liquor & Gifts",
//     "DELIVERY ADDRESS": "815 TX-35",
//     "CITY, STATE, ZIP": "Port Lavaca, TX 77979",
//     "ZIP CODE": 77979,
//     "Latitude": "28.631.825",
//     "Longitude": "-96.632.506"
//   },
//   {
//     "ACCOUNT NAME": "Proof Liquor & Deli",
//     "DELIVERY ADDRESS": "3420 FM 967 STE B107",
//     "CITY, STATE, ZIP": "BUDA, TX 78610",
//     "ZIP CODE": 78610,
//     "Latitude": "3.009.607",
//     "Longitude": "-97.880.923"
//   },
//   {
//     "ACCOUNT NAME": "Propose Liquor",
//     "DELIVERY ADDRESS": "614 E University Ave",
//     "CITY, STATE, ZIP": "Georgetown, TX 78626",
//     "ZIP CODE": 78626,
//     "Latitude": "3.063.312",
//     "Longitude": "-97.671.086"
//   },
//   {
//     "ACCOUNT NAME": "Rock Liquor - Cedar Park",
//     "DELIVERY ADDRESS": "2875 W WHITESTONE BLVD STE 140",
//     "CITY, STATE, ZIP": "Cedar Park, TX 78613",
//     "ZIP CODE": 78613,
//     "Latitude": "30.515.694",
//     "Longitude": "-9.787.299"
//   },
//   {
//     "ACCOUNT NAME": "Salute Liquor",
//     "DELIVERY ADDRESS": "105 E. Old Settlers Blvd #104",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.532.909",
//     "Longitude": "-97.687.039"
//   },
//   {
//     "ACCOUNT NAME": "Salute Liquor-Dripping Springs",
//     "DELIVERY ADDRESS": "2400 West US 290 Suite 4",
//     "CITY, STATE, ZIP": "Dripping Springs, TX 78620",
//     "ZIP CODE": 78620,
//     "Latitude": "30.206.035",
//     "Longitude": "-98.123.371"
//   },
//   {
//     "ACCOUNT NAME": "Sam's Liquor & Smoke Shop",
//     "DELIVERY ADDRESS": "970 FM 967 Suite B",
//     "CITY, STATE, ZIP": "Buda, TX 78610",
//     "ZIP CODE": 78610,
//     "Latitude": "30.093.144",
//     "Longitude": "-97.848.275"
//   },
//   {
//     "ACCOUNT NAME": "Siena Liquor & Smoke Shop",
//     "DELIVERY ADDRESS": "51 Limmer Loop, Suite 200",
//     "CITY, STATE, ZIP": "Round Rock, TX 78665",
//     "ZIP CODE": 78665,
//     "Latitude": "30.562.687",
//     "Longitude": "-97.604.956"
//   },
//   {
//     "ACCOUNT NAME": "Space Liquor",
//     "DELIVERY ADDRESS": "30713 Chi Chi Dr.",
//     "CITY, STATE, ZIP": "Georgetown, TX 78628",
//     "ZIP CODE": 78628,
//     "Latitude": "3.071.584",
//     "Longitude": "-9.766.382"
//   },
//   {
//     "ACCOUNT NAME": "Spec's Wholesale Austin - 296",
//     "DELIVERY ADDRESS": "7900 Industry Way",
//     "CITY, STATE, ZIP": "Austin, TX 78744",
//     "ZIP CODE": 78744,
//     "Latitude": "30.184.093",
//     "Longitude": "-97.694.036"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Arbor Walk - 62",
//     "DELIVERY ADDRESS": "10515 N. Mopac Expwy",
//     "CITY, STATE, ZIP": "Austin, TX 78759",
//     "ZIP CODE": 78759,
//     "Latitude": "30.391.367",
//     "Longitude": "-97.733.119"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Bee Cave - 65",
//     "DELIVERY ADDRESS": "13015 Shops Pkwy",
//     "CITY, STATE, ZIP": "Bee Cave, TX 78738",
//     "ZIP CODE": 78738,
//     "Latitude": "30.307.598",
//     "Longitude": "-97.945.921"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Brodie Lane - 61",
//     "DELIVERY ADDRESS": "4970 West HWY 290",
//     "CITY, STATE, ZIP": "Austin, TX 78735",
//     "ZIP CODE": 78735,
//     "Latitude": "30.198.578",
//     "Longitude": "-98.179.951"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Cedar Park - 179",
//     "DELIVERY ADDRESS": "13530 Ronald Regan Blvd. #100",
//     "CITY, STATE, ZIP": "Cedar Park, TX 78613",
//     "ZIP CODE": 78613,
//     "Latitude": "30.670.604",
//     "Longitude": "-97.840.104"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Four Points - 77",
//     "DELIVERY ADDRESS": "10601 N. FM 620, Suite 107",
//     "CITY, STATE, ZIP": "Austin, TX 78726",
//     "ZIP CODE": 78726,
//     "Latitude": "3.044.422",
//     "Longitude": "-97.832.146"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Georgetown - 95",
//     "DELIVERY ADDRESS": "1013 W University Ave. #200",
//     "CITY, STATE, ZIP": "Georgetown, TX 78628",
//     "ZIP CODE": 78628,
//     "Latitude": "30.631.697",
//     "Longitude": "-97.694.229"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, High Meadow- 58",
//     "DELIVERY ADDRESS": "12611 Hymeadow Dr.",
//     "CITY, STATE, ZIP": "Austin, TX 78729",
//     "ZIP CODE": 78729,
//     "Latitude": "30.457.857",
//     "Longitude": "-97.791.437"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Highland Park - 60",
//     "DELIVERY ADDRESS": "5775 Airport Blvd., Ste 100",
//     "CITY, STATE, ZIP": "Austin, TX 78752",
//     "ZIP CODE": 78752,
//     "Latitude": "30.322.312",
//     "Longitude": "-97.713.799"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Killeen - 75",
//     "DELIVERY ADDRESS": "2500 E. Central Texas Expy, Suite C",
//     "CITY, STATE, ZIP": "Killeen, TX 76543",
//     "ZIP CODE": 76543,
//     "Latitude": "31.087.861",
//     "Longitude": "-97.718.715"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Lamar Street - 11",
//     "DELIVERY ADDRESS": "914 N Lamar Blvd.",
//     "CITY, STATE, ZIP": "Austin, TX 78703",
//     "ZIP CODE": 78703,
//     "Latitude": "30.274.812",
//     "Longitude": "-97.752.633"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Pflugerville -221",
//     "DELIVERY ADDRESS": "19000 Limestone Commercial Dr.",
//     "CITY, STATE, ZIP": "Pflugerville, TX 78660",
//     "ZIP CODE": 78660,
//     "Latitude": "3.047.182",
//     "Longitude": "-97.597.129"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Round Rock - 63",
//     "DELIVERY ADDRESS": "201 University Blvd, Suite 600",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.559.134",
//     "Longitude": "-97.689.197"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, South Park Meadows - 64",
//     "DELIVERY ADDRESS": "9900 S. IH35 Service",
//     "CITY, STATE, ZIP": "Austin, TX 78748",
//     "ZIP CODE": 78748,
//     "Latitude": "30.202.447",
//     "Longitude": "-97.760.326"
//   },
//   {
//     "ACCOUNT NAME": "Spec's, Temple - 66",
//     "DELIVERY ADDRESS": "3550 S. General Bruce Dr.",
//     "CITY, STATE, ZIP": "Temple, TX 76504",
//     "ZIP CODE": 76504,
//     "Latitude": "31.094.543",
//     "Longitude": "-97.382.484"
//   },
//   {
//     "ACCOUNT NAME": "Stand Alone Liquor",
//     "DELIVERY ADDRESS": "204 N Fort Hood St.",
//     "CITY, STATE, ZIP": "Killeen, TX 76541",
//     "ZIP CODE": 76541,
//     "Latitude": "31.121.916",
//     "Longitude": "-97.742.186"
//   },
//   {
//     "ACCOUNT NAME": "Starbeam",
//     "DELIVERY ADDRESS": "305 Sonny Drive Unit 100",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "30.568.542",
//     "Longitude": "-97.852.791"
//   },
//   {
//     "ACCOUNT NAME": "Starbeam Liquor #2",
//     "DELIVERY ADDRESS": "6081 FM 1660 # 200",
//     "CITY, STATE, ZIP": "Hutto, TX 78634",
//     "ZIP CODE": 78634,
//     "Latitude": "30.558.859",
//     "Longitude": "-9.754.377"
//   },
//   {
//     "ACCOUNT NAME": "Starbeam Liquor #1",
//     "DELIVERY ADDRESS": "133 E. Front St. #200",
//     "CITY, STATE, ZIP": "Hutto, TX 78634",
//     "ZIP CODE": 78634,
//     "Latitude": "30.542.912",
//     "Longitude": "-97.542.695"
//   },
//   {
//     "ACCOUNT NAME": "Starbeam Liquor #3",
//     "DELIVERY ADDRESS": "13107 FM 969 Suite 200",
//     "CITY, STATE, ZIP": "Austin, TX 78724",
//     "ZIP CODE": 78724,
//     "Latitude": "30.251.683",
//     "Longitude": "-97.596.627"
//   },
//   {
//     "ACCOUNT NAME": "Starbeam Liquor #6",
//     "DELIVERY ADDRESS": "2300 Windy Hill Rd.",
//     "CITY, STATE, ZIP": "Kyle, TX 78640",
//     "ZIP CODE": 78640,
//     "Latitude": "30.031.827",
//     "Longitude": "-97.809.584"
//   },
//   {
//     "ACCOUNT NAME": "Steiner Ranch Liquor",
//     "DELIVERY ADDRESS": "5145 FM 620 North Suite L130",
//     "CITY, STATE, ZIP": "Austin, TX 78732",
//     "ZIP CODE": 78732,
//     "Latitude": "30.389.184",
//     "Longitude": "-97.883.582"
//   },
//   {
//     "ACCOUNT NAME": "T Liquor",
//     "DELIVERY ADDRESS": "2000 N Mays St. #300",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.528.154",
//     "Longitude": "-97.688.265"
//   },
//   {
//     "ACCOUNT NAME": "Temple Liquor & Smoke",
//     "DELIVERY ADDRESS": "2204 W Avenue M, Suite A",
//     "CITY, STATE, ZIP": "Temple, TX 76504",
//     "ZIP CODE": 76504,
//     "Latitude": "3.109.082",
//     "Longitude": "-97.369.082"
//   },
//   {
//     "ACCOUNT NAME": "Teravista Liquor",
//     "DELIVERY ADDRESS": "2080 Westinghouse Road",
//     "CITY, STATE, ZIP": "Georgetown, TX 78626",
//     "ZIP CODE": 78626,
//     "Latitude": "30.586.841",
//     "Longitude": "-97.658.535"
//   },
//   {
//     "ACCOUNT NAME": "Texas Star Liquor",
//     "DELIVERY ADDRESS": "1949 Fire Cracker Dr. ste 100",
//     "CITY, STATE, ZIP": "Buda, TX 78610",
//     "ZIP CODE": 78610,
//     "Latitude": "30.087.897",
//     "Longitude": "-97.811.395"
//   },
//   {
//     "ACCOUNT NAME": "Texas Star Liquor - Pflugerville",
//     "DELIVERY ADDRESS": "18801 Weiss Lane,  Bldg. #2, Suite 200",
//     "CITY, STATE, ZIP": "Pflugerville, TX 78660",
//     "ZIP CODE": 78660,
//     "Latitude": "30.449.488",
//     "Longitude": "-97.559.741"
//   },
//   {
//     "ACCOUNT NAME": "The Austin Shaker - Pleasant Valley",
//     "DELIVERY ADDRESS": "420 N. Pleasant Valley Rd. B",
//     "CITY, STATE, ZIP": "Austin, TX 78702",
//     "ZIP CODE": 78702,
//     "Latitude": "30.256.388",
//     "Longitude": "-97.711.458"
//   },
//   {
//     "ACCOUNT NAME": "The Austin Shaker - Airport Blvd.",
//     "DELIVERY ADDRESS": "1199 Airport Blvd.",
//     "CITY, STATE, ZIP": "Austin, TX 78702",
//     "ZIP CODE": 78702,
//     "Latitude": "30.276.511",
//     "Longitude": "-97.699.722"
//   },
//   {
//     "ACCOUNT NAME": "The Austin Shaker - Oak Hill",
//     "DELIVERY ADDRESS": "7626 HWY 71 W Suite 102",
//     "CITY, STATE, ZIP": "Austin, TX 78735",
//     "ZIP CODE": 78735,
//     "Latitude": "30.217.958",
//     "Longitude": "-97.690.351"
//   },
//   {
//     "ACCOUNT NAME": "The Austin Shaker - US 183",
//     "DELIVERY ADDRESS": "2500 S Hwy 183, Bldg 4 Suite 430",
//     "CITY, STATE, ZIP": "Austin, TX 78744",
//     "ZIP CODE": 78744,
//     "Latitude": "30.210.597",
//     "Longitude": "-97.683.563"
//   },
//   {
//     "ACCOUNT NAME": "The Liquor Cabinet",
//     "DELIVERY ADDRESS": "15301 Ronald Reagan Blvd Suite 11110",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "30.560.074",
//     "Longitude": "-97.800.093"
//   },
//   {
//     "ACCOUNT NAME": "Tipsy Liquor",
//     "DELIVERY ADDRESS": "300 Hesters Crossing Rd. Suite A8",
//     "CITY, STATE, ZIP": "Round Rock, TX 78681",
//     "ZIP CODE": 78681,
//     "Latitude": "30.488.148",
//     "Longitude": "-97.679.671"
//   },
//   {
//     "ACCOUNT NAME": "Top Barrel",
//     "DELIVERY ADDRESS": "11620 Hero Way West",
//     "CITY, STATE, ZIP": "Leander, TX 78641",
//     "ZIP CODE": 78641,
//     "Latitude": "30.579.244",
//     "Longitude": "-97.865.895"
//   },
//   {
//     "ACCOUNT NAME": "Top Liquor",
//     "DELIVERY ADDRESS": "1400 E. Old Settlers Blvd #108",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.539.364",
//     "Longitude": "-97.670.574"
//   },
//   {
//     "ACCOUNT NAME": "Travis Heights Wine and Spirits",
//     "DELIVERY ADDRESS": "1948 S I-35 Frontage Road",
//     "CITY, STATE, ZIP": "Austin, TX 78704",
//     "ZIP CODE": 78704,
//     "Latitude": "30.527.353",
//     "Longitude": "-97.691.338"
//   },
//   {
//     "ACCOUNT NAME": "Twin Liquors-Airport Road",
//     "DELIVERY ADDRESS": "5639 Airport Blvd. Austin, TX 78751",
//     "CITY, STATE, ZIP": "Austin, TX 78751",
//     "ZIP CODE": 78751,
//     "Latitude": "30.319.021",
//     "Longitude": "-97.711.309"
//   },
//   {
//     "ACCOUNT NAME": "Twin Liquors (Store 017)",
//     "DELIVERY ADDRESS": "13497 Research Blvd",
//     "CITY, STATE, ZIP": "Austin, TX 78750",
//     "ZIP CODE": 78750,
//     "Latitude": "30.437.954",
//     "Longitude": "-97.776.129"
//   },
//   {
//     "ACCOUNT NAME": "Twin Liquors - Palm Valley Blvd (048)",
//     "DELIVERY ADDRESS": "1700 E Palm Valley Blvd, Suite 560",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.518.991",
//     "Longitude": "-97.657.699"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor #2  - Copperas Cove",
//     "DELIVERY ADDRESS": "1202 US HWY 190",
//     "CITY, STATE, ZIP": "Copperas Cove 76522",
//     "ZIP CODE": 76522,
//     "Latitude": "31.119.883",
//     "Longitude": "-97.891.562"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor #6* - Jarrell",
//     "DELIVERY ADDRESS": "11840 N INTERSTATE 35",
//     "CITY, STATE, ZIP": "Jarrell, TX 76537",
//     "ZIP CODE": 76537,
//     "Latitude": "30.814.747",
//     "Longitude": "-97.610.255"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor #5 - Jarrell",
//     "DELIVERY ADDRESS": "181 TOWN CENTER BLVD STE 600",
//     "CITY, STATE, ZIP": "Jarrell, TX 76537",
//     "ZIP CODE": 76537,
//     "Latitude": "30.817.775",
//     "Longitude": "-97.615.225"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor #7  - Manor",
//     "DELIVERY ADDRESS": "11828 RING DR STE 107",
//     "CITY, STATE, ZIP": "Manor, TX 78653",
//     "ZIP CODE": 78653,
//     "Latitude": "30.347.674",
//     "Longitude": "-97.541.132"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor #8 Austin",
//     "DELIVERY ADDRESS": "1601 Ranch Road FM 2222 Suite F",
//     "CITY, STATE, ZIP": "Austin, TX 78730",
//     "ZIP CODE": 78730,
//     "Latitude": "30.199.154",
//     "Longitude": "-97.827.685"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor #9 - Austin (MOPAC)",
//     "DELIVERY ADDRESS": "14701 N MO PAC EXPY",
//     "CITY, STATE, ZIP": "AUSTIN, TX 78728",
//     "ZIP CODE": 78728,
//     "Latitude": "30.472.361",
//     "Longitude": "-97.702.319"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor - Harker Heights",
//     "DELIVERY ADDRESS": "300 W CENTRAL TEXAS EXPY STE 103",
//     "CITY, STATE, ZIP": "Harker Heights, TX 76548",
//     "ZIP CODE": 76548,
//     "Latitude": "31.071.145",
//     "Longitude": "-97.675.623"
//   },
//   {
//     "ACCOUNT NAME": "Uptown Liquor - Liberty Hill",
//     "DELIVERY ADDRESS": "14365 W STATE HIGHWAY 29 STE 4",
//     "CITY, STATE, ZIP": "Liberty Hill, TX 78642",
//     "ZIP CODE": 78642,
//     "Latitude": "30.672.181",
//     "Longitude": "-97.920.944"
//   },
//   {
//     "ACCOUNT NAME": "Urban Liquor",
//     "DELIVERY ADDRESS": "11211 US Highway 290 E Suite 200B",
//     "CITY, STATE, ZIP": "Manor, TX 78653",
//     "ZIP CODE": 78653,
//     "Latitude": "30.350.823",
//     "Longitude": "-97.500.362"
//   },
//   {
//     "ACCOUNT NAME": "V Liquors",
//     "DELIVERY ADDRESS": "2800 E Palm Valley Blvd, Unit 140",
//     "CITY, STATE, ZIP": "Round Rock, TX 78665",
//     "ZIP CODE": 78665,
//     "Latitude": "30.523.181",
//     "Longitude": "-97.639.635"
//   },
//   {
//     "ACCOUNT NAME": "West Campus Liquor",
//     "DELIVERY ADDRESS": "709 W 22nd St. Ste 600",
//     "CITY, STATE, ZIP": "Austin, TX 78705",
//     "ZIP CODE": 78705,
//     "Latitude": "3.028.617",
//     "Longitude": "-97.745.204"
//   },
//   {
//     "ACCOUNT NAME": "Nueces Liquor",
//     "DELIVERY ADDRESS": "2700 NUECES STREET #103",
//     "CITY, STATE, ZIP": "Austin, TX 78705",
//     "ZIP CODE": 78705,
//     "Latitude": "30.292.076",
//     "Longitude": "-97.743.214"
//   },
//   {
//     "ACCOUNT NAME": "Whiskey Liquor - Hutto",
//     "DELIVERY ADDRESS": "560 HIGHWAY 79 STE A800",
//     "CITY, STATE, ZIP": "Hutto, TX 78634",
//     "ZIP CODE": 78634,
//     "Latitude": "30.519.066",
//     "Longitude": "-97.675.289"
//   },
//   {
//     "ACCOUNT NAME": "Wiggys Wine & Spirits",
//     "DELIVERY ADDRESS": "1104 N Lamar Blvd",
//     "CITY, STATE, ZIP": "Austin, TX 78703",
//     "ZIP CODE": 78703,
//     "Latitude": "30.276.333",
//     "Longitude": "-97.751.949"
//   },
//   {
//     "ACCOUNT NAME": "Wisky's Liquor #3 - Round Rock",
//     "DELIVERY ADDRESS": "1350 E Palm Valley Blvd. Ste. #100",
//     "CITY, STATE, ZIP": "Round Rock, TX 78664",
//     "ZIP CODE": 78664,
//     "Latitude": "30.518.278",
//     "Longitude": "-97.665.324"
//   },
//   {
//     "ACCOUNT NAME": "Wwhisky's Liquor - Hudson Bend",
//     "DELIVERY ADDRESS": "5000 Hudson Bend Rd. Unit F",
//     "CITY, STATE, ZIP": "Austin, TX 78734",
//     "ZIP CODE": 78734,
//     "Latitude": "30.412.007",
//     "Longitude": "-97.927.237"
//   },
//   {
//     "ACCOUNT NAME": "Yeti Liquor",
//     "DELIVERY ADDRESS": "2900 N Quinlan Park Rd Suite 110",
//     "CITY, STATE, ZIP": "Austin, TX 78732",
//     "ZIP CODE": 78732,
//     "Latitude": "30.369.178",
//     "Longitude": "-97.892.631"
//   },
//   {
//     "ACCOUNT NAME": "Zeke's Liquor",
//     "DELIVERY ADDRESS": "1711 E Cesar Chavez St. ste. D",
//     "CITY, STATE, ZIP": "Austin, TX 78702",
//     "ZIP CODE": 78702,
//     "Latitude": "30.257.378",
//     "Longitude": "-97.726.049"
//   }
// ]


window.verdaderoBars = 




[ 





{
   "ACCOUNT NAME": "29th Street Ballroom",
   "DELIVERY ADDRESS": "2906 Fruth Street",
   "CITY, STATE, ZIP": "Austin, TX 78705",
   "ZIP CODE": 78705,
   "COUNTY": "Travis",
   "Latitude": 30.29533,
   "Longitude": -97.742026
 },
 {
   "ACCOUNT NAME": "Black Sheep Lodge",
   "DELIVERY ADDRESS": "2108 S Lamar Blvd",
   "CITY, STATE, ZIP": "Austin, TX 78704",
   "ZIP CODE": 78704,
   "COUNTY": "Travis",
   "Latitude": 30.248383,
   "Longitude": -97.771191
 },
 {
   "ACCOUNT NAME": "Blue Corn Harvest Bar and Grill-Cedar Park",
   "DELIVERY ADDRESS": "700 E Whitestone Blvd",
   "CITY, STATE, ZIP": "Cedar Park, TX 78613",
   "ZIP CODE": 78613,
   "COUNTY": "Williamson",
   "Latitude": 30.52261,
   "Longitude": -97.821936
 },
 {
   "ACCOUNT NAME": "Blue Corn Harvest Bar and Grill-Leander",
   "DELIVERY ADDRESS": "11840 Hero Way",
   "CITY, STATE, ZIP": "Leander, TX 78641",
   "ZIP CODE": 78641,
   "COUNTY": "Williamson",
   "Latitude": 30.577967,
   "Longitude": -97.868739
 },
 {
   "ACCOUNT NAME": "Blue Corn Harvest Bar and Grill-Round Rock",
   "DELIVERY ADDRESS": "2980 Joe Dimaggio Blvd",
   "CITY, STATE, ZIP": "Round Rock, TX 78665",
   "ZIP CODE": 78665,
   "COUNTY": "Williamson",
   "Latitude": 30.524702,
   "Longitude": -97.638041
 },
 {
   "ACCOUNT NAME": "Cantina Holly",
   "DELIVERY ADDRESS": "2500 E Sixth Street",
   "CITY, STATE, ZIP": "Austin, TX 78702",
   "ZIP CODE": 78702,
   "COUNTY": "Travis",
   "Latitude": 30.259023,
   "Longitude": -97.714458
 },
 {
   "ACCOUNT NAME": "Casa Jalisco Bar and Grill",
   "DELIVERY ADDRESS": "125 Co-Op Blvd",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "COUNTY": "Williamson",
   "Latitude": 30.54295,
   "Longitude": -97.552315
 },
 {
   "ACCOUNT NAME": "Catering By Rosemary",
   "DELIVERY ADDRESS": "2110 San Jacinto Blvd",
   "CITY, STATE, ZIP": "Austin, TX 78705",
   "ZIP CODE": 78705,
   "COUNTY": "Travis",
   "Latitude": 30.283301,
   "Longitude": -97.733898
 },
 {
   "ACCOUNT NAME": "Crazy Conchaz",
   "DELIVERY ADDRESS": "87 Rainey Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.259667,
   "Longitude": -97.738141
 },
 {
   "ACCOUNT NAME": "DKR Stadium",
   "DELIVERY ADDRESS": "405 Deloss Dodds Way",
   "CITY, STATE, ZIP": "Austin, TX 78712",
   "ZIP CODE": 78712,
   "COUNTY": "Travis",
   "Latitude": 30.284668,
   "Longitude": -97.732463
 },
 {
   "ACCOUNT NAME": "Downright Austin A Renaissance Hotel",
   "DELIVERY ADDRESS": "701 E 11th Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.270606,
   "Longitude": -97.734241
 },
 {
   "ACCOUNT NAME": "El Cockfight",
   "DELIVERY ADDRESS": "121 E 5th Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.266622,
   "Longitude": -97.742049
 },
 {
   "ACCOUNT NAME": "Float Pool and Patio Bar",
   "DELIVERY ADDRESS": "2828 Seawall Blvd",
   "CITY, STATE, ZIP": "Galveston, TX 77550",
   "ZIP CODE": 77550,
   "COUNTY": "Galveston",
   "Latitude": 29.285915,
   "Longitude": -94.794385
 },
 {
   "ACCOUNT NAME": "Gnar Bar",
   "DELIVERY ADDRESS": "219 E Sixth Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.26723,
   "Longitude": -97.740793
 },
 {
   "ACCOUNT NAME": "Haymaker",
   "DELIVERY ADDRESS": "2310 Manor Road",
   "CITY, STATE, ZIP": "Austin, TX 78722",
   "ZIP CODE": 78722,
   "COUNTY": "Travis",
   "Latitude": 30.2848,
   "Longitude": -97.717581
 },
 {
   "ACCOUNT NAME": "Hilton",
   "DELIVERY ADDRESS": "500 E 4th Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.26507,
   "Longitude": -97.738631
 },
 {
   "ACCOUNT NAME": "Hotel Lucine",
   "DELIVERY ADDRESS": "1002 Seawall Blvd",
   "CITY, STATE, ZIP": "Galveston, TX 77550",
   "ZIP CODE": 77550,
   "COUNTY": "Galveston",
   "Latitude": 29.300788,
   "Longitude": -94.776347
 },
 {
   "ACCOUNT NAME": "Julio's Mexican Restaurant",
   "DELIVERY ADDRESS": "560 US-79",
   "CITY, STATE, ZIP": "Hutto, TX 78634",
   "ZIP CODE": 78634,
   "COUNTY": "Williamson",
   "Latitude": 30.542896,
   "Longitude": -97.556568
 },
 {
   "ACCOUNT NAME": "JW Marriott",
   "DELIVERY ADDRESS": "110 E 2nd Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.264392,
   "Longitude": -97.743409
 },
 {
   "ACCOUNT NAME": "La Casita Mexican Restaurant",
   "DELIVERY ADDRESS": "800 W Pecan Street",
   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
   "ZIP CODE": 78660,
   "COUNTY": "Travis",
   "Latitude": 30.443003,
   "Longitude": -97.626488
 },
 {
   "ACCOUNT NAME": "Little Woodrow's",
   "DELIVERY ADDRESS": "520 W 6th Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.26979,
   "Longitude": -97.748116
 },
 {
   "ACCOUNT NAME": "Long Branch Saloon",
   "DELIVERY ADDRESS": "107 W Main Street",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "COUNTY": "Williamson",
   "Latitude": 30.508278,
   "Longitude": -97.679201
 },
 {
   "ACCOUNT NAME": "Lucky Lounge",
   "DELIVERY ADDRESS": "904 Seawall Blvd",
   "CITY, STATE, ZIP": "Galveston, TX 77550",
   "ZIP CODE": 77550,
   "COUNTY": "Galveston",
   "Latitude": 29.301719,
   "Longitude": -94.775186
 },
 {
   "ACCOUNT NAME": "Mama Dearest",
   "DELIVERY ADDRESS": "515 Pedernales Street",
   "CITY, STATE, ZIP": "Austin, TX 78702",
   "ZIP CODE": 78702,
   "COUNTY": "Travis",
   "Latitude": 30.258509,
   "Longitude": -97.714679
 },
 {
   "ACCOUNT NAME": "Manchaca Springs Salloon",
   "DELIVERY ADDRESS": "737 W FM 1626",
   "CITY, STATE, ZIP": "Manchaca, TX 78652",
   "ZIP CODE": 78652,
   "COUNTY": "Travis",
   "Latitude": 30.140396,
   "Longitude": -97.82648
 },
 {
   "ACCOUNT NAME": "Moody Center",
   "DELIVERY ADDRESS": "2001 Robert Dedmon Drive",
   "CITY, STATE, ZIP": "Austin, TX 78712",
   "ZIP CODE": 78712,
   "COUNTY": "Travis",
   "Latitude": 30.281451,
   "Longitude": -97.730824
 },
 {
   "ACCOUNT NAME": "Nomade",
   "DELIVERY ADDRESS": "1506 S 1st Street",
   "CITY, STATE, ZIP": "Austin, TX 78704",
   "ZIP CODE": 78704,
   "COUNTY": "Travis",
   "Latitude": 30.249717,
   "Longitude": -97.755291
 },
 {
   "ACCOUNT NAME": "Once Over Coffee Bar",
   "DELIVERY ADDRESS": "2009 S First Street",
   "CITY, STATE, ZIP": "Austin, TX 78704",
   "ZIP CODE": 78704,
   "COUNTY": "Travis",
   "Latitude": 30.244893,
   "Longitude": -97.757107
 },
 {
   "ACCOUNT NAME": "Parkside",
   "DELIVERY ADDRESS": "301 E 6th Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.267138,
   "Longitude": -97.740324
 },
 {
   "ACCOUNT NAME": "Seven",
   "DELIVERY ADDRESS": "120 E 7th Street",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.268845,
   "Longitude": -97.741295
 },
 {
   "ACCOUNT NAME": "Taco Flats",
   "DELIVERY ADDRESS": "900 Ranch Road 620 Suite 1",
   "CITY, STATE, ZIP": "Lakeway, TX 78734",
   "ZIP CODE": 78734,
   "COUNTY": "Travis",
   "Latitude": 30.373293,
   "Longitude": -97.947295
 },
 {
   "ACCOUNT NAME": "The Brass Tap",
   "DELIVERY ADDRESS": "204 E Main Street",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "COUNTY": "Williamson",
   "Latitude": 30.509174,
   "Longitude": -97.677531
 },
 {
   "ACCOUNT NAME": "The Dime",
   "DELIVERY ADDRESS": "103 E Main Street",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "COUNTY": "Williamson",
   "Latitude": 30.5085,
   "Longitude": -97.678497
 },
 {
   "ACCOUNT NAME": "The Hole In The Wall",
   "DELIVERY ADDRESS": "2538 Guadalupe Street",
   "CITY, STATE, ZIP": "Austin, TX 78705",
   "ZIP CODE": 78705,
   "COUNTY": "Travis",
   "Latitude": 30.290058,
   "Longitude": -97.741622
 },
 {
   "ACCOUNT NAME": "The Point ATX",
   "DELIVERY ADDRESS": "CLOSED",
   "CITY, STATE, ZIP": "",
   "ZIP CODE": null,
   "COUNTY": "",
   "Latitude": 0,
   "Longitude": 0
 },
 {
   "ACCOUNT NAME": "The Stephen F. Austin Royal Sonesta Hotel",
   "DELIVERY ADDRESS": "701 Congress Avenue",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.26906,
   "Longitude": -97.74198
 },
 {
   "ACCOUNT NAME": "Third Base",
   "DELIVERY ADDRESS": "3107 I-35 South",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "COUNTY": "Williamson",
   "Latitude": 30.477616,
   "Longitude": -97.671647
 },
 {
   "ACCOUNT NAME": "Tweedy's",
   "DELIVERY ADDRESS": "2908 Fruth Street",
   "CITY, STATE, ZIP": "Austin, TX 78705",
   "ZIP CODE": 78705,
   "COUNTY": "Travis",
   "Latitude": 30.2955,
   "Longitude": -97.741709
 },
 {
   "ACCOUNT NAME": "Urban Eat Drink",
   "DELIVERY ADDRESS": "411 W Main Street",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "COUNTY": "Williamson",
   "Latitude": 30.506802,
   "Longitude": -97.682383
 },
 {
   "ACCOUNT NAME": "Uno Mariscos O Que",
   "DELIVERY ADDRESS": "1350 E Palm Valley Blvd",
   "CITY, STATE, ZIP": "Round Rock, TX 78664",
   "ZIP CODE": 78664,
   "COUNTY": "Williamson",
   "Latitude": 30.518119,
   "Longitude": -97.665176
 },
 {
   "ACCOUNT NAME": "Victory Lap",
   "DELIVERY ADDRESS": "85 Rainey Street ",
   "CITY, STATE, ZIP": "Austin, TX 78701",
   "ZIP CODE": 78701,
   "COUNTY": "Travis",
   "Latitude": 30.259539,
   "Longitude": -97.738188
 }
]
  // {
  //   "ACCOUNT NAME": "Black Sheep Lodge",
  //   "DELIVERY ADDRESS": "2108 S Lamar Blvd",
  //   "Latitude": "30.248383",
  //   "Longitude": "-97.771191",
  //   "CITY, STATE, ZIP": "Austin, TX 78704",
  //   "ZIP CODE": 78704
  // },
  // {
  //   "ACCOUNT NAME": "Blue Corn Harvest Bar and Grill-Cedar Park",
  //   "DELIVERY ADDRESS": "700 E Whitestone Blvd",
  //   "Latitude": "30.522610",
  //   "Longitude": "-97.821936",
  //   "CITY, STATE, ZIP": "Cedar Park, TX 78613",
  //   "ZIP CODE": 78613
  // },
  // {
  //   "ACCOUNT NAME": "Blue Corn Harvest Bar and Grill-Leander",
  //   "DELIVERY ADDRESS": "11840 Hero Way",
  //   "Latitude": "30.577967",
  //   "Longitude": "-97.868739",
  //   "CITY, STATE, ZIP": "Leander, TX 78641",
  //   "ZIP CODE": 78641
  // },
  // {
  //   "ACCOUNT NAME": "Blue Corn Harvest Bar and Grill-Round Rock",
  //   "DELIVERY ADDRESS": "2980 Joe Dimaggio Blvd",
  //   "Latitude": "30.524702",
  //   "Longitude": "-97.638041",
  //   "CITY, STATE, ZIP": "Round Rock, TX 78665",
  //   "ZIP CODE": 78665
  // },
  // {
  //   "ACCOUNT NAME": "Cantina Holly",
  //   "DELIVERY ADDRESS": "2500 E Sixth Street",
  //   "Latitude": "30.259023",
  //   "Longitude": "-97.714458",
  //   "CITY, STATE, ZIP": "Austin, TX 78702",
  //   "ZIP CODE": 78702
  // },
  // {
  //   "ACCOUNT NAME": "Casa Jalisco Bar and Grill",
  //   "DELIVERY ADDRESS": "125 Co-Op Blvd",
  //   "Latitude": "30.542950",
  //   "Longitude": "-97.552315",
  //   "CITY, STATE, ZIP": "Hutto, TX 78634",
  //   "ZIP CODE": 78634
  // },
  // {
  //   "ACCOUNT NAME": "Catering By Rosemary",
  //   "DELIVERY ADDRESS": "2110 San Jacinto Blvd",
  //   "Latitude": "30.283301",
  //   "Longitude": "-97.733898",
  //   "CITY, STATE, ZIP": "Austin, TX 78705",
  //   "ZIP CODE": 78705
  // },
  // {
  //   "ACCOUNT NAME": "Crazy Conchaz",
  //   "DELIVERY ADDRESS": "87 Rainey Street",
  //   "Latitude": "30.259667",
  //   "Longitude": "-97.738141",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // },
  // {
  //   "ACCOUNT NAME": "Downright Austin A Renaissance Hotel",
  //   "DELIVERY ADDRESS": "701 E 11th Street",
  //   "Latitude": "30.270606",
  //   "Longitude": "-97.734241",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // },
  // {
  //   "ACCOUNT NAME": "El Cockfight",
  //   "DELIVERY ADDRESS": "121 E 5th Street",
  //   "Latitude": "30.266622",
  //   "Longitude": "-97.742049",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // },
  // {
  //   "ACCOUNT NAME": "Hotel Lucine",
  //   "DELIVERY ADDRESS": "1002 Seawall Blvd",
  //   "Latitude": "29.300788",
  //   "Longitude": "-94.776347",
  //   "CITY, STATE, ZIP": "Galveston, TX 77550",
  //   "ZIP CODE": 77550
  // },
  // {
  //   "ACCOUNT NAME": "Julio's Mexican Restaurant",
  //   "DELIVERY ADDRESS": "560 US-79",
  //   "Latitude": "30.519066",
  //   "Longitude": "-97.675289",
  //   "CITY, STATE, ZIP": "Hutto, TX 78634",
  //   "ZIP CODE": 78634
  // },
  // {
  //   "ACCOUNT NAME": "JW Marriott",
  //   "DELIVERY ADDRESS": "110 E 2nd Street",
  //   "Latitude": "30.264392",
  //   "Longitude": "-97.743409",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // },
  // {
  //   "ACCOUNT NAME": "La Casita Mexican Restaurant",
  //   "DELIVERY ADDRESS": "800 W Pecan Street",
  //   "Latitude": "30.443003",
  //   "Longitude": "-97.626488",
  //   "CITY, STATE, ZIP": "Pflugerville, TX 78660",
  //   "ZIP CODE": 78660
  // },
  // {
  //   "ACCOUNT NAME": "Long Branch Saloon",
  //   "DELIVERY ADDRESS": "107 W Main Street",
  //   "Latitude": "30.508278",
  //   "Longitude": "-97.679201",
  //   "CITY, STATE, ZIP": "Round Rock, TX 78664",
  //   "ZIP CODE": 78664
  // },
  // {
  //   "ACCOUNT NAME": "Mama Dearest",
  //   "DELIVERY ADDRESS": "515 Pedernales Street",
  //   "Latitude": "30.258509",
  //   "Longitude": "-97.714679",
  //   "CITY, STATE, ZIP": "Austin, TX 78702",
  //   "ZIP CODE": 78702
  // },
  // {
  //   "ACCOUNT NAME": "Manchaca Springs Salloon",
  //   "DELIVERY ADDRESS": "737 W FM 1626",
  //   "Latitude": "30.140396",
  //   "Longitude": "-97.826480",
  //   "CITY, STATE, ZIP": "Manchaca, TX 78652",
  //   "ZIP CODE": 78652
  // },
  // {
  //   "ACCOUNT NAME": "Nomade",
  //   "DELIVERY ADDRESS": "1506 S 1st Street",
  //   "Latitude": "30.249717",
  //   "Longitude": "-97.755291",
  //   "CITY, STATE, ZIP": "Austin, TX 78704",
  //   "ZIP CODE": 78704
  // },
  // {
  //   "ACCOUNT NAME": "Once Over Coffee Bar",
  //   "DELIVERY ADDRESS": "2009 S First Street",
  //   "Latitude": "30.244893",
  //   "Longitude": "-97.757107",
  //   "CITY, STATE, ZIP": "Austin, TX 78704",
  //   "ZIP CODE": 78704
  // },
  // {
  //   "ACCOUNT NAME": "Parkside",
  //   "DELIVERY ADDRESS": "301 E 6th Street",
  //   "Latitude": "30.267138",
  //   "Longitude": "-97.740324",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // },
  // {
  //   "ACCOUNT NAME": "Seven",
  //   "DELIVERY ADDRESS": "120 E 7th Street",
  //   "Latitude": "30.268845",
  //   "Longitude": "-97.741295",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // },
  // {
  //   "ACCOUNT NAME": "Taco Flats",
  //   "DELIVERY ADDRESS": "900 Ranch Road 620 Suite 1",
  //   "Latitude": "30.355033",
  //   "Longitude": "-97.960635",
  //   "CITY, STATE, ZIP": "Lakeway, TX 78734",
  //   "ZIP CODE": 78734
  // },
  // {
  //   "ACCOUNT NAME": "The Brass Tap",
  //   "DELIVERY ADDRESS": "204 E Main Street",
  //   "Latitude": "30.509174",
  //   "Longitude": "-97.677531",
  //   "CITY, STATE, ZIP": "Round Rock, TX 78664",
  //   "ZIP CODE": 78664
  // },
  // {
  //   "ACCOUNT NAME": "The Dime",
  //   "DELIVERY ADDRESS": "103 E Main Street",
  //   "Latitude": "30.508500",
  //   "Longitude": "-97.678497",
  //   "CITY, STATE, ZIP": "Round Rock, TX 78664",
  //   "ZIP CODE": 78664
  // },
  // {
  //   "ACCOUNT NAME": "The Hole In The Wall",
  //   "DELIVERY ADDRESS": "2538 Guadalupe Street",
  //   "Latitude": "30.290058",
  //   "Longitude": "-97.741622",
  //   "CITY, STATE, ZIP": "Austin, TX 78705",
  //   "ZIP CODE": 78705
  // },
  // {
  //   "ACCOUNT NAME": "The Stephen F. Austin Royal Sonesta Hotel",
  //   "DELIVERY ADDRESS": "701 Congress Avenue",
  //   "Latitude": "30.269060",
  //   "Longitude": "-97.741980",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // },
  // {
  //   "ACCOUNT NAME": "Third Base",
  //   "DELIVERY ADDRESS": "3107 I-35 South",
  //   "Latitude": "30.477616",
  //   "Longitude": "-97.671647",
  //   "CITY, STATE, ZIP": "Round Rock, TX 78664",
  //   "ZIP CODE": 78664
  // },
  // {
  //   "ACCOUNT NAME": "Tweedy's",
  //   "DELIVERY ADDRESS": "2908 Fruth Street",
  //   "Latitude": "30.295500",
  //   "Longitude": "-97.741709",
  //   "CITY, STATE, ZIP": "Austin, TX 78705",
  //   "ZIP CODE": 78705
  // },
  // {
  //   "ACCOUNT NAME": "Urban Eat Drink",
  //   "DELIVERY ADDRESS": "411 W Main Street",
  //   "Latitude": "30.506802",
  //   "Longitude": "-97.682383",
  //   "CITY, STATE, ZIP": "Round Rock, TX 78664",
  //   "ZIP CODE": 78664
  // },
  // {
  //   "ACCOUNT NAME": "Uno Mariscos O Que",
  //   "DELIVERY ADDRESS": "1350 E Palm Valley Blvd",
  //   "Latitude": "30.518119",
  //   "Longitude": "-97.665176",
  //   "CITY, STATE, ZIP": "Round Rock, TX 78664",
  //   "ZIP CODE": 78664
  // },
  // {
  //   "ACCOUNT NAME": "Victory Lap",
  //   "DELIVERY ADDRESS": "85 Rainey Street",
  //   "Latitude": "30.259539",
  //   "Longitude": "-97.738188",
  //   "CITY, STATE, ZIP": "Austin, TX 78701",
  //   "ZIP CODE": 78701
  // }

